(function(){
function scalarSpec(value) {
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value !== "string" || !/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(value.trim())) return null;
  const n=Number(value);return Number.isFinite(n)?n:null;
}

function canonicalPattern(value) {
  if (typeof value!=="string") return null;
  const m=value.trim().match(/^(\d+)\s*[x×]\s*(\d+(?:\.\d+)?)$/i);
  if(!m)return null;
  const holes=Number(m[1]),pcd=Number(m[2]);
  if(!Number.isSafeInteger(holes)||holes<3||holes>12||pcd<40||pcd>400)return null;
  return holes+"x"+pcd;
}

function parseCatalogVariant(raw) {
  const issues=[];
  const fail=reason=>({variant:null,issue:{id:raw?.id,sku:raw?.sku,title:raw?.product?.title,reason,options:raw?.selectedOptions}});
  if(!raw||!Array.isArray(raw.selectedOptions)||typeof raw.id!=="string"||!/^gid:\/\/shopify\/ProductVariant\/\d+$/.test(raw.id))return fail("Invalid variant identity or options");
  const opts={};
  for(const o of raw.selectedOptions){
    if(typeof o.name!=="string"||typeof o.value!=="string")return fail("Malformed options");
    const name=o.name.trim().toLowerCase().replace(/\s+/g," ");
    if(name in opts)return fail("Duplicate option name");
    opts[name]=o.value.trim();
  }
  const size=opts.size||"";
  if(/\b(driver|passenger|left|right)\b/i.test(size))return fail("Directional wheel: paired sides require separate handling");
  const sm=size.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)$/i);
  if(!sm)return fail("Size is missing, custom, or not a fixed diameter × width");
  const diameter=Number(sm[1]),width=Number(sm[2]);
  if(!(diameter>0&&width>0))return fail("Nonpositive wheel dimensions");
  let pcd=opts.pcd,et=opts.et;
  if(opts["pcd et"]){
    const combined=opts["pcd et"].match(/^PCD:\s*(.*?)\s+ET:\s*(.*?)$/i);
    if(!combined||pcd!==undefined||et!==undefined)return fail("Ambiguous combined PCD / ET");
    [,pcd,et]=combined;
  }
  if(typeof pcd!=="string"||typeof et!=="string")return fail("Missing PCD or ET");
  const offset=scalarSpec(et.replace(/\s*mm\s*$/i,""));
  if(offset===null)return fail("ET is missing, custom, or a range");
  const inchPCDs={"4.5":114.3,"4.75":120.65,"5":127,"5.5":139.7,"6.5":165.1};
  const parts=pcd.split("/");
  if(!parts.length)return fail("Missing PCD");
  const patterns=[];
  for(const part of parts){
    const m=part.trim().match(/^(\d+)\s*[x×]\s*(\d+(?:\.\d+)?)$/i);
    if(!m)return fail("PCD is custom or ambiguous");
    const numeric=Number(m[2]);
    const mm=numeric<20?inchPCDs[String(numeric)]:numeric;
    const pattern=mm===undefined?null:canonicalPattern(m[1]+"x"+mm);
    if(!pattern)return fail("Unsupported PCD notation");
    if(!patterns.includes(pattern))patterns.push(pattern);
  }
  const handle=raw.product?.handle,id=raw.id.split("/").pop();
  if(typeof handle!=="string"||!/^[a-z0-9][a-z0-9-]*$/.test(handle))return fail("Invalid product handle");
  return {variant:{
    id,sku:raw.sku||"",price:raw.price,available:raw.availableForSale===true,
    diameter,width,offset,patterns,finish:opts.finish||null,
    product:{...raw.product},
    productUrl:"https://www.wheelsoutlet.com/products/"+handle+"?variant="+id
  },issue:null};
}

function matchBasicWheelCandidates(vehicle, variants) {
  const dimensions = value=>{
    if(!value||typeof value!=="object"||Array.isArray(value)||value.staggered===true||value.setup==="staggered")return null;
    const diameter=scalarSpec(value.diameter),width=scalarSpec(value.width),offset=scalarSpec(value.offset);
    return diameter!==null&&diameter>0&&width!==null&&width>0&&offset!==null?{diameter,width,offset}:null;
  };
  const boltPattern=canonicalPattern(vehicle?.boltPattern);
  if(!boltPattern||!Array.isArray(vehicle?.wheels)||!Array.isArray(variants))throw new TypeError("Normalized vehicle and variant data required");
  const refs=vehicle.wheels.flatMap((source,index)=>{const d=dimensions(source);return d?[{...d,stock:source.stock===true,index,source}]:[]});
  if(!refs.length)throw new TypeError("No complete same-size vehicle wheel reference");
  const candidates=[];
  for(const v of variants){
    const spec=dimensions(v);
    if(!spec||typeof v.id!=="string"||!/^\d+$/.test(v.id)||!v.available||v.available!==true||v.product?.status!=="ACTIVE"||!v.product?.onlineStoreUrl)continue;
    if(!Array.isArray(v.patterns))continue;
    const patterns=v.patterns.map(canonicalPattern);
    if(patterns.some(p=>!p)||!patterns.includes(boltPattern))continue;
    const outwardLimit=spec.diameter===15||spec.diameter===16?70:40;
    let best=null;
    for(const ref of refs){
      if(spec.diameter!==ref.diameter)continue;
      const half=(spec.width-ref.width)*12.7,outwardMm=half+ref.offset-spec.offset,inwardMm=half+spec.offset-ref.offset;
      if(!Number.isFinite(outwardMm)||!Number.isFinite(inwardMm)||outwardMm>outwardLimit+1e-9||inwardMm>15+1e-9)continue;
      const score=Math.abs(outwardMm)+Math.abs(inwardMm);
      if(!best||score<best.score||(score===best.score&&ref.stock&&!best.reference.stock))best={reference:ref,outwardMm,inwardMm,score};
    }
    if(best)candidates.push({classification:"suggested",variant:v,specification:{...spec,boltPattern},...best,limits:{outwardMm:outwardLimit,inwardMm:15}});
  }
  candidates.sort((a,b)=>a.specification.diameter-b.specification.diameter||a.specification.width-b.specification.width||a.specification.offset-b.specification.offset||a.variant.id.localeCompare(b.variant.id));
  return candidates;
}


// Diameter eligibility and lateral geometry are independent policies. Every
// suggestion uses an actual widest complete reference for BOTH limits; when
// the vehicle has staggered references, each axle is evaluated independently.
function normalizePlusSizePolicy(options = {}) {
  if (!options || typeof options !== 'object' || Array.isArray(options)) {
    throw new TypeError('Plus-size options must be an object.');
  }
  if (Object.keys(options).some(key => key !== 'maxDiameterIncrease')) {
    throw new TypeError('Use the maxDiameterIncrease option.');
  }
  const increase = options.maxDiameterIncrease;
  if (increase !== undefined && increase !== 1 && increase !== 2 && increase !== 3) {
    throw new TypeError('maxDiameterIncrease must be 1, 2 or 3 inches when provided.');
  }
  return {maxDiameterIncrease: increase === undefined ? 0 : increase, anchorPolicy: 'maximum-stock-or-smallest-listed'};
}

function plusSizeDimensions(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value) ||
      value.staggered === true || value.setup === 'staggered') return null;
  const diameter = scalarSpec(value.diameter);
  const width = scalarSpec(value.width);
  const offset = scalarSpec(value.offset);
  return diameter !== null && diameter > 0 && width !== null && width > 0 &&
    offset !== null ? {diameter, width, offset} : null;
}

function matchReferencePool(boltPattern, references, variants, policy) {
  const stock = references.filter(reference => reference.stock);
  const ceilingReferenceDiameter = stock.length
    ? Math.max(...stock.map(reference => reference.diameter))
    : Math.min(...references.map(reference => reference.diameter));
  const maxDiameter = ceilingReferenceDiameter + policy.maxDiameterIncrease;
  const diameterAnchors = stock.length ? stock : references.filter(reference =>
    reference.diameter === ceilingReferenceDiameter);
  const widestWidth = Math.max(...references.map(reference => reference.width));
  const lateralAnchors = references.filter(reference => reference.width === widestWidth);
  const candidates = [], epsilon = 1e-9;

  for (const variant of variants) {
    const specification = plusSizeDimensions(variant);
    if (!specification || typeof variant.id !== 'string' || !/^\d+$/.test(variant.id) ||
        variant.available !== true || variant.product?.status !== 'ACTIVE' ||
        !variant.product?.onlineStoreUrl || !Array.isArray(variant.patterns)) continue;
    const patterns = variant.patterns.map(canonicalPattern);
    if (patterns.some(pattern => !pattern) || !patterns.includes(boltPattern)) continue;

    const listedReferences = references.filter(reference =>
      reference.diameter === specification.diameter);
    const explicitlyListed = listedReferences.length > 0;
    // Keep explicitly listed sizes, even above the expansion ceiling. A derived
    // size must be larger than a permitted actual diameter anchor and under the
    // original ceiling; a wider or larger listed alternative cannot raise it.
    const diameterReferences = explicitlyListed ? listedReferences :
      policy.maxDiameterIncrease > 0 && specification.diameter <= maxDiameter + epsilon
        ? diameterAnchors.filter(reference => specification.diameter > reference.diameter + epsilon)
        : [];
    if (!diameterReferences.length) continue;
    diameterReferences.sort((a, b) =>
      b.diameter - a.diameter || Number(b.stock) - Number(a.stock) ||
      b.width - a.width || a.offset - b.offset || a.index - b.index);
    const diameterReference = diameterReferences[0];
    const diameterIncrease = explicitlyListed ? 0 : specification.diameter - diameterReference.diameter;
    const referenceBasis = diameterReference.stock ? 'stock' : 'listed';

    const outwardLimit = specification.diameter === 15 || specification.diameter === 16 ? 70 : 40;
    let best = null;
    for (const reference of lateralAnchors) {
      const halfWidthDifference = (specification.width - reference.width) * 12.7;
      const outwardMm = halfWidthDifference + reference.offset - specification.offset;
      const inwardMm = halfWidthDifference + specification.offset - reference.offset;
      if (!Number.isFinite(outwardMm) || !Number.isFinite(inwardMm) ||
          outwardMm > outwardLimit + epsilon || inwardMm > 15 + epsilon) continue;
      const score = Math.abs(outwardMm) + Math.abs(inwardMm);
      const candidate = {reference, outwardMm, inwardMm, score};
      // Stable geometry-first ties: closest offset, stock, closest diameter,
      // then numerical diameter/offset. Never combine axes from different rows.
      const order = best ? score - best.score ||
        Math.abs(reference.offset - specification.offset) - Math.abs(best.reference.offset - specification.offset) ||
        Number(best.reference.stock) - Number(reference.stock) ||
        Math.abs(reference.diameter - specification.diameter) - Math.abs(best.reference.diameter - specification.diameter) ||
        reference.diameter - best.reference.diameter || reference.offset - best.reference.offset ||
        reference.index - best.reference.index : -1;
      if (!best || order < 0) best = candidate;
    }
    if (!best) continue;
    candidates.push({
      classification: 'suggested',
      variant,
      specification: {...specification, boltPattern},
      ...best,
      limits: {outwardMm: outwardLimit, inwardMm: 15},
      diameterReference,
      diameterIncrease,
      referenceBasis,
      lateralReferencePolicy: 'widest-valid-square',
      lateralReferenceBasis: best.reference.stock ? 'stock' : 'listed',
      rule: explicitlyListed ? 'listed' : 'plus-size',
      ruleLabel: explicitlyListed
        ? 'Listed diameter; lateral comparison uses the widest vehicle wheel reference'
        : 'Diameter up to ' + maxDiameter + ' inches (' +
          (stock.length ? 'maximum stock' : 'smallest listed') + ' reference + ' +
          policy.maxDiameterIncrease + '); lateral comparison uses the widest vehicle wheel reference',
      sizing: {
        type: explicitlyListed ? 'listed' : 'plus-size',
        diameterIncreaseInches: diameterIncrease,
        maxIncreaseInches: policy.maxDiameterIncrease,
        ceilingReferenceDiameterInches: ceilingReferenceDiameter,
        maxDiameterInches: maxDiameter,
        referenceBasis
      }
    });
  }
  candidates.sort((a, b) =>
    a.specification.diameter - b.specification.diameter ||
    a.specification.width - b.specification.width ||
    a.specification.offset - b.specification.offset ||
    a.variant.id.localeCompare(b.variant.id)
  );
  return candidates;
}

function matchPlusSizeWheelCandidates(vehicle, variants, options = {}) {
  const policy = normalizePlusSizePolicy(options);
  if (!vehicle || typeof vehicle !== 'object' || !Array.isArray(variants) ||
      (vehicle.axleReferences !== undefined && !Array.isArray(vehicle.axleReferences))) {
    throw new TypeError('Normalized vehicle and variant data required');
  }
  const rawPairs = vehicle.axleReferences || [];
  const pairs = [], seen = new Set();
  for (const [index, source] of rawPairs.entries()) {
    if (!source || typeof source !== 'object' || Array.isArray(source) ||
        typeof source.id !== 'string' || !source.id.trim() || source.id.length > 240 ||
        !['square', 'staggered'].includes(source.setup)) continue;
    const front = plusSizeDimensions(source.front), rear = plusSizeDimensions(source.rear);
    const frontPattern = canonicalPattern(source.front?.boltPattern);
    const rearPattern = canonicalPattern(source.rear?.boltPattern);
    if (!front || !rear || !frontPattern || !rearPattern) continue;
    if (seen.has(source.id)) throw new TypeError('Duplicate vehicle reference pair identity');
    seen.add(source.id);
    pairs.push({id: source.id, index, source, stock: source.stock === true,
      front: {...front, boltPattern: frontPattern}, rear: {...rear, boltPattern: rearPattern}});
  }
  const staggered = rawPairs.some(pair => pair?.setup === 'staggered') ||
    pairs.some(pair => pair.front.diameter !== pair.rear.diameter ||
      pair.front.width !== pair.rear.width || pair.front.offset !== pair.rear.offset ||
      pair.front.boltPattern !== pair.rear.boltPattern);
  if (!staggered) {
    const boltPattern = canonicalPattern(vehicle.boltPattern);
    if (!boltPattern || !Array.isArray(vehicle.wheels)) {
      throw new TypeError('Normalized vehicle and variant data required');
    }
    const references = vehicle.wheels.flatMap((source, index) => {
      const dimensions = plusSizeDimensions(source);
      return dimensions ? [{...dimensions, stock: source.stock === true, index, source}] : [];
    });
    if (!references.length) throw new TypeError('No complete same-size vehicle wheel reference');
    return matchReferencePool(boltPattern, references, variants, policy);
  }
  if (!pairs.length) throw new TypeError('No complete front-and-rear vehicle wheel reference');

  const byVariant = new Map();
  for (const axle of ['front', 'rear']) {
    // PCD and dimensions are always taken from this axle of complete real pairs.
    // The other axle's width, offset and diameter cannot enter this pool.
    const pools = new Map();
    for (const pair of pairs) {
      const side = pair[axle], boltPattern = side.boltPattern;
      if (!pools.has(boltPattern)) pools.set(boltPattern, []);
      pools.get(boltPattern).push({...side, stock: pair.stock, index: pair.index,
        source: pair.source[axle], pairId: pair.id, sourcePair: pair.source, axle});
    }
    for (const [boltPattern, references] of pools) {
      const matches = matchReferencePool(boltPattern, references, variants, policy);
      for (const match of matches) {
        const scoped = {...match, axle, fitmentScope: 'axle',
          lateralReferencePolicy: 'widest-valid-axle',
          referencePairId: match.reference.pairId,
          diameterReferencePairId: match.diameterReference.pairId};
        const id = match.variant.id;
        if (!byVariant.has(id)) byVariant.set(id, {});
        const existing = byVariant.get(id)[axle];
        if (!existing || scoped.score < existing.score ||
            (scoped.score === existing.score && scoped.referencePairId.localeCompare(existing.referencePairId) < 0)) {
          byVariant.get(id)[axle] = scoped;
        }
      }
    }
  }
  const results = [];
  for (const axleMatches of byVariant.values()) {
    // Top-level legacy fields are a representative only. The UI must select the
    // relevant axleMatches entry before showing axle-specific geometry or labels.
    const representative = axleMatches.front || axleMatches.rear;
    results.push({...representative,
      axle: axleMatches.front && axleMatches.rear ? 'both' : axleMatches.front ? 'front' : 'rear',
      fitmentScope: 'axle', axleMatches});
  }
  results.sort((a, b) =>
    a.specification.diameter - b.specification.diameter ||
    a.specification.width - b.specification.width ||
    a.specification.offset - b.specification.offset ||
    a.variant.id.localeCompare(b.variant.id));
  return results;
}


/**
 * Filter categories only. Keep the catalog finish unchanged for product labels,
 * swatches, images and variant links. A mixed finish may belong to many groups.
 */
const FINISH_FILTER_COLORS = ['Black', 'Silver', 'Gold', 'White', 'Bronze'];

function finishFilterGroups(exactFinish) {
  if (typeof exactFinish !== 'string') return [];
  const label = exactFinish.trim();
  if (!label) return [];
  const lowercase = label.toLowerCase();
  // Color names use literal substrings. Gun Metal also accepts Graphite and
  // spacing/hyphen variations without changing the original finish label.
  const groups = FINISH_FILTER_COLORS.filter(color =>
    lowercase.includes(color.toLowerCase()));
  const compact = lowercase.replace(/[\s\u2010-\u2015-]+/g, '');
  if (compact.includes('gunmetal') || lowercase.includes('graphite')) {
    groups.push('Gun Metal');
  }
  return groups.length ? groups : [label];
}

function finishFilterOptions(finishes = []) {
  if (!Array.isArray(finishes)) {
    throw new TypeError('Finish values must be an array.');
  }
  return [...new Set(finishes.flatMap(finishFilterGroups))]
    .sort((a, b) => a.localeCompare(b));
}

function finishMatchesFilter(exactFinish, selectedGroups = []) {
  if (!Array.isArray(selectedGroups) && !(selectedGroups instanceof Set)) {
    throw new TypeError('Selected finish groups must be an array or Set.');
  }
  const selected = selectedGroups instanceof Set ? selectedGroups : new Set(selectedGroups);
  if (selected.size === 0) return true;
  return finishFilterGroups(exactFinish).some(group => selected.has(group));
}



const FAST_CATALOG_SCHEMA = 'wo-fitment-catalog-v1';
const FAST_PRODUCT_SCHEMA = 'wo-fitment-product-v1';
const FAST_STORE_ORIGINS = new Set(['https://www.wheelsoutlet.com', 'https://wheelsoutlet.com']);

const FAST_CATALOG_CACHE_SCHEMA = 'wo-fitment-cache-v1';
const FAST_CATALOG_CACHE_DB = 'wo-fitment-catalog-v1';
const FAST_CATALOG_CACHE_STORE = 'catalog';
const FAST_CATALOG_CACHE_TTL = 300000;
const FAST_CATALOG_CACHE_MAX_BYTES = 12 * 1024 * 1024;
function catalogCacheScope(base, currency) {
  const shopify = globalThis.Shopify;
  const themeId = String(shopify?.theme?.id || '');
  if (!/^[1-9]\d*$/.test(themeId) || !/^[A-Z]{3}$/.test(currency || '')) return null;
  const preview = base.searchParams.get('preview_theme_id') || '';
  const language = String(shopify?.locale || globalThis.document?.documentElement?.lang || '');
  const country = String(shopify?.country || '');
  const routeRoot = String(shopify?.routes?.root || '/');
  return JSON.stringify([FAST_CATALOG_CACHE_SCHEMA, base.origin, base.pathname, currency,
    themeId, preview, String(shopify?.theme?.role || ''), language, country, routeRoot]);
}
// One replaceable record bounds disk use; storage is optional and never blocks
// normal catalog loading indefinitely. Cache content contains Shopify data only.
function catalogCacheOperation(action, record, signal) {
  return new Promise(resolve => {
    let db = null, transaction = null, finished = false;
    const finish = value => {
      if (finished) return;
      finished = true; clearTimeout(timer); signal?.removeEventListener('abort', cancel);
      if (db) db.close();
      resolve(value);
    };
    const cancel = () => { try { transaction?.abort(); } catch {} finish(null); };
    const timer = setTimeout(cancel, 800);
    if (signal?.aborted) { cancel(); return; }
    signal?.addEventListener('abort', cancel, {once:true});
    try {
      if (!globalThis.indexedDB) { finish(null); return; }
      const open = globalThis.indexedDB.open(FAST_CATALOG_CACHE_DB, 1);
      open.onupgradeneeded = () => {
        if (!open.result.objectStoreNames.contains(FAST_CATALOG_CACHE_STORE)) open.result.createObjectStore(FAST_CATALOG_CACHE_STORE);
      };
      open.onerror = open.onblocked = () => finish(null);
      open.onsuccess = () => {
        if (finished) { open.result.close(); return; }
        db = open.result; db.onversionchange = () => db.close();
        try {
          transaction = db.transaction(FAST_CATALOG_CACHE_STORE, action === 'read' ? 'readonly' : 'readwrite');
          const store = transaction.objectStore(FAST_CATALOG_CACHE_STORE);
          const get = store.get('current'); let value = null;
          get.onsuccess = () => {
            if (finished || signal?.aborted) { cancel(); return; }
            try {
            const previous = get.result;
            if (action === 'read') value = previous || null;
            else if (action === 'write') {
              // A slower earlier scan must not replace a newer same-scope scan.
              if (!previous || previous.key !== record.key || !(previous.freshnessAt > record.freshnessAt)) store.put(record, 'current');
            } else if (action === 'delete' && previous && previous.key === record.key &&
                previous.freshnessAt === record.freshnessAt && previous.checkedAt === record.checkedAt) store.delete('current');
            else if (action === 'delete-scope' && previous?.key === record.key) store.delete('current');
            } catch { cancel(); }
          };
          transaction.oncomplete = () => finish(value);
          transaction.onerror = transaction.onabort = () => finish(null);
        } catch { finish(null); }
      };
    } catch { finish(null); }
  });
}
function catalogCacheRecordValid(record, key, currency) {
  const now = Date.now();
  return record && record.schema === FAST_CATALOG_CACHE_SCHEMA && record.key === key &&
    record.currency === currency && Number.isFinite(record.freshnessAt) &&
    record.freshnessAt === Date.parse(record.checkedAt) && record.freshnessAt <= now &&
    now - record.freshnessAt < FAST_CATALOG_CACHE_TTL &&
    Array.isArray(record.pages) && Array.isArray(record.overflow);
}

function catalogError(message) { return new Error(message || 'The current wheel catalog could not be loaded. Please try again.'); }
function catalogAssert(ok, message) { if (!ok) throw catalogError(message); }
function catalogInteger(n, minimum = 0, maximum = 25000) { return Number.isSafeInteger(n) && n >= minimum && n <= maximum; }
function catalogId(id) { return typeof id === 'string' && /^[1-9]\d{0,23}$/.test(id); }
function catalogHandle(handle) { return typeof handle === 'string' && /^[a-z0-9][a-z0-9-]{0,239}$/.test(handle); }
function catalogImage(image, origin = 'https://www.wheelsoutlet.com') {
  if (!image || typeof image.src !== 'string') return null;
  try {
    const url = new URL(image.src, origin);
    if (url.protocol !== 'https:' || url.username || url.password) return null;
    if (!['cdn.shopify.com', 'www.wheelsoutlet.com', 'wheelsoutlet.com', 'wheelsoutlet-2.myshopify.com'].includes(url.hostname) && !url.hostname.endsWith('.shopifycdn.com')) return null;
    return {src: url.href, alt: typeof image.alt === 'string' ? image.alt.slice(0,800) : ''};
  } catch { return null; }
}
function catalogVariantIdentity(variants, total) {
  catalogAssert(Array.isArray(variants) && catalogInteger(total, 0, 10000), 'The wheel catalog has an invalid variant count.');
  const seen = new Set();
  for (const v of variants) {
    catalogAssert(v && catalogId(v.id) && !seen.has(v.id), 'The wheel catalog contains missing or repeated variant records.');
    seen.add(v.id);
  }
}
function validateFastCatalogPage(payload, expectedPage, expectedCollection) {
  catalogAssert(payload && payload.schema === FAST_CATALOG_SCHEMA, 'The fast wheel catalog is not available in this theme yet.');
  catalogAssert(typeof payload.currency === 'string' && /^[A-Z]{3}$/.test(payload.currency), 'The wheel catalog currency is missing.');
  catalogAssert(catalogHandle(payload.collection) && (!expectedCollection || payload.collection === expectedCollection), 'A different collection was returned.');
  catalogAssert(catalogInteger(payload.totalProducts) && catalogInteger(payload.pageSize, 1, 250), 'The wheel catalog page count is invalid.');
  const pages = Math.max(1, Math.ceil(payload.totalProducts / payload.pageSize));
  catalogAssert(payload.pages === pages || (payload.totalProducts === 0 && payload.pages === 0), 'The wheel catalog is incomplete.');
  catalogAssert(payload.page === expectedPage && catalogInteger(payload.page, 1, pages), 'A different wheel catalog page was returned.');
  const expectedCount = Math.min(payload.pageSize, Math.max(0, payload.totalProducts - (payload.page - 1) * payload.pageSize));
  catalogAssert(Array.isArray(payload.products) && payload.products.length === expectedCount, 'The wheel catalog page was truncated. Please try again.');
  for (const p of payload.products) {
    catalogAssert(p && catalogId(p.id) && catalogHandle(p.handle), 'The wheel catalog contains an invalid product.');
    catalogVariantIdentity(p.variants, p.variantsCount);
    catalogAssert(p.variantsReturned === p.variants.length && p.variants.length <= Math.min(p.variantsCount, 250), 'The wheel catalog contains an incomplete variant list.');
  }
  return {...payload, pages};
}
function validateFastProductPage(payload, expectedPage, descriptor, currency) {
  catalogAssert(payload && payload.schema === FAST_PRODUCT_SCHEMA, 'The remaining wheel options could not be loaded.');
  catalogAssert(payload.id === descriptor.id && payload.handle === descriptor.handle && payload.currency === currency, 'Different wheel options were returned.');
  catalogAssert(payload.variantsCount === descriptor.variantsCount && catalogInteger(payload.pageSize, 1, 50), 'The wheel options changed while loading. Please try again.');
  const pages = Math.max(1, Math.ceil(descriptor.variantsCount / payload.pageSize));
  catalogAssert(payload.pages === pages && payload.page === expectedPage && catalogInteger(payload.page, 1, pages), 'The remaining wheel options are incomplete.');
  catalogVariantIdentity(payload.variants, descriptor.variantsCount);
  const expectedCount = Math.min(payload.pageSize, descriptor.variantsCount - (payload.page - 1) * payload.pageSize);
  catalogAssert(payload.variantsReturned === payload.variants.length && payload.variants.length === expectedCount, 'A wheel option page was truncated.');
  return payload;
}
function normalizeFastCatalogProduct(raw, currency, origin) {
  catalogAssert(raw.variants.length === raw.variantsCount, 'A wheel has unresolved variant pages.');
  const vendor = typeof raw.vendor === 'string' ? raw.vendor : '';
  const type = typeof raw.type === 'string' ? raw.type : '';
  if (!['wheel', 'wheels'].includes(type.toLowerCase()) && !['vors','mrr'].includes(vendor.toLowerCase())) return {product:null, variants:[], excluded:0};
  const image = catalogImage(raw.image, origin);
  const images = Array.isArray(raw.images) ? raw.images.map(i=>catalogImage(i, origin)).filter(Boolean) : [];
  const options = Array.isArray(raw.options) ? raw.options : [];
  const product = {
    id:'gid://shopify/Product/'+raw.id, handle:raw.handle,
    title:typeof raw.title === 'string' ? raw.title : raw.handle, vendor,
    cardTitleBase:typeof raw.cardTitleBase === 'string' && raw.cardTitleBase.trim() ? raw.cardTitleBase.trim() : null,
    productType:type, status:'ACTIVE', onlineStoreUrl:origin+'/products/'+raw.handle,
    image, images, options, variantsCount:raw.variantsCount
  };
  const variants = []; let excluded = 0;
  let finishIndex = options.findIndex(o=>typeof o === 'string' && o.trim().toLowerCase() === 'finish');
  if (finishIndex < 0) finishIndex = options.findIndex(o=>typeof o === 'string' && /^(color|colour)$/i.test(o.trim()));
  const finishValues = new Set(raw.variants.flatMap(v=>Array.isArray(v.options) && typeof v.options[finishIndex] === 'string' ? [v.options[finishIndex].trim().toLowerCase()] : []));
  const singleFinish = finishIndex < 0 || finishValues.size === 1;
  const finishImages = new Map();
  for (const rawVariant of raw.variants) {
    const i = catalogImage(rawVariant.image, origin);
    const f = finishIndex >= 0 && Array.isArray(rawVariant.options) ? rawVariant.options[finishIndex] : null;
    if (i && typeof f === 'string' && !finishImages.has(f.trim().toLowerCase())) finishImages.set(f.trim().toLowerCase(), i);
  }
  for (const v of raw.variants) {
    if (v.available !== true) continue;
    if (!catalogInteger(v.price, 0, Number.MAX_SAFE_INTEGER) || options.length < 1 || options.length > 3 || !Array.isArray(v.options) || v.options.length !== options.length) { excluded++; continue; }
    const parsed = parseCatalogVariant({
      id:'gid://shopify/ProductVariant/'+v.id, sku:typeof v.sku === 'string' ? v.sku : '',
      price:(v.price/100).toFixed(2), availableForSale:true,
      selectedOptions:options.map((name,i)=>({name:i === finishIndex ? 'Finish' : name,value:v.options[i]})), product
    });
    if (!parsed.variant) { excluded++; continue; }
    const exactImage = catalogImage(v.image, origin) || (parsed.variant.finish ? finishImages.get(parsed.variant.finish.trim().toLowerCase()) : null) || (singleFinish ? image : null);
    variants.push({...parsed.variant, currency, backorder:v.backorder === true, image:exactImage,
      productUrl:origin+'/products/'+raw.handle+'?variant='+v.id});
  }
  return {product, variants, excluded};
}
function normalizeFastCatalogPages(pages, overflowPages = new Map(), origin = 'https://www.wheelsoutlet.com') {
  catalogAssert(FAST_STORE_ORIGINS.has(origin), 'Use Wheels Outlet to load the wheel catalog.');
  catalogAssert(Array.isArray(pages) && pages.length, 'The wheel catalog is empty or incomplete.');
  const first = validateFastCatalogPage(pages.find(p=>p?.page===1), 1);
  catalogAssert(pages.length === first.pages, 'Not all wheel catalog pages were loaded.');
  const products = [], variants = [], seenProducts = new Set(), seenVariants = new Set(); let excluded = 0;
  for (let page = 1; page <= first.pages; page++) {
    const matches = pages.filter(p=>p?.page===page);
    catalogAssert(matches.length === 1, 'The wheel catalog has a missing or repeated page.');
    const data = validateFastCatalogPage(matches[0], page, first.collection);
    catalogAssert(data.currency === first.currency && data.totalProducts === first.totalProducts && data.pageSize === first.pageSize, 'The wheel catalog changed while loading. Please try again.');
    for (const initial of data.products) {
      catalogAssert(!seenProducts.has(initial.id), 'A wheel appeared on more than one catalog page. Please try again.'); seenProducts.add(initial.id);
      let raw = initial;
      if (raw.variants.length < raw.variantsCount) {
        const extra = overflowPages.get(raw.id);
        catalogAssert(Array.isArray(extra) && extra.length, 'A wheel has unresolved variant pages.');
        const a = validateFastProductPage(extra.find(p=>p?.page===1), 1, raw, first.currency);
        catalogAssert(extra.length === a.pages, 'Not all wheel option pages were loaded.');
        const completed = [];
        for (let n = 1; n <= a.pages; n++) {
          const one = extra.filter(p=>p?.page===n);
          catalogAssert(one.length === 1, 'A wheel option page was missing or repeated.');
          const checked = validateFastProductPage(one[0], n, raw, first.currency);
          catalogAssert(checked.pageSize === a.pageSize, 'Wheel option page sizes changed.');
          completed.push(...checked.variants);
        }
        catalogVariantIdentity(completed, raw.variantsCount);
        catalogAssert(completed.length === raw.variantsCount, 'A wheel has unresolved variant pages.');
        raw = {...raw, variants:completed, variantsReturned:completed.length};
      }
      for (const v of raw.variants) { catalogAssert(!seenVariants.has(v.id), 'A variant appeared on more than one wheel.'); seenVariants.add(v.id); }
      const out = normalizeFastCatalogProduct(raw, first.currency, origin);
      if (out.product) products.push(out.product);
      variants.push(...out.variants); excluded += out.excluded;
    }
  }
  catalogAssert(seenProducts.size === first.totalProducts, 'The complete wheel catalog was not received.');
  return {variants, products, excluded, productsChecked:seenProducts.size, currency:first.currency};
}
async function catalogPool(items, task, concurrency = 4) {
  let index = 0; const results = new Array(items.length);
  await Promise.all(Array.from({length:Math.min(concurrency, items.length)}, async()=>{
    while (index < items.length) { const n = index++; results[n] = await task(items[n]); }
  }));
  return results;
}
async function loadFastCatalog({signal, baseUrl, onProgress, force = false, currency} = {}) {
  const current = typeof location !== 'undefined' ? new URL(location.href) : null;
  const routeRoot = globalThis.Shopify?.routes?.root;
  const defaultRoot = typeof routeRoot === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(routeRoot) ? routeRoot : '/';
  const base = new URL(baseUrl || defaultRoot + 'collections/all', current?.origin || 'https://www.wheelsoutlet.com');
  catalogAssert(FAST_STORE_ORIGINS.has(base.origin) && /^(?:\/[a-z]{2}(?:-[A-Za-z]{2})?)?\/collections\/[a-z0-9][a-z0-9-]*\/?$/.test(base.pathname), 'Use the Wheels Outlet collection to load the wheel catalog.');
  const handle = base.pathname.replace(/\/$/,'').split('/').pop();
  const localePrefix = base.pathname.slice(0, base.pathname.indexOf('/collections/'));
  const preview = base.searchParams.get('preview_theme_id') || (current?.origin === base.origin ? current.searchParams.get('preview_theme_id') : null);
  base.search = ''; base.hash = '';
  if (preview && /^\d+$/.test(preview)) base.searchParams.set('preview_theme_id',preview);
  base.searchParams.set('view','wo-fitment-data');
  const controller = new AbortController();
  const abort = ()=>controller.abort(signal?.reason);
  if (signal?.aborted) abort(); else signal?.addEventListener('abort',abort,{once:true});
  let requestCount = 0, loadedPages = 0, totalPages = 1, productsChecked = 0, totalProducts = 0;
  const expectedCurrency = currency === undefined ? globalThis.Shopify?.currency?.active : currency;
  if (expectedCurrency !== undefined) catalogAssert(typeof expectedCurrency === 'string' && /^[A-Z]{3}$/.test(expectedCurrency), 'The active store currency is invalid.');
  const cacheKey = catalogCacheScope(base, expectedCurrency);
  let checkedAt;
  const progress = phase=>{if(typeof onProgress === 'function') onProgress({phase,requestCount,loadedPages,totalPages,productsChecked,totalProducts});};
  const get = async(url)=>{
    if (controller.signal.aborted) throw controller.signal.reason || new DOMException('Aborted','AbortError');
    requestCount++;
    const requestController = new AbortController();
    const cancelRequest = ()=>requestController.abort(controller.signal.reason);
    controller.signal.addEventListener('abort',cancelRequest,{once:true});
    let timedOut = false;
    const timer = setTimeout(()=>{timedOut=true;requestController.abort();},20000);
    try {
      const response = await fetch(url.href,{method:'GET',credentials:'same-origin',cache:'no-store',redirect:'error',signal:requestController.signal,headers:{Accept:'text/html'}});
      if (!response.ok) throw catalogError('The current wheel catalog could not be loaded. Please try again.');
      let data; try { data = await response.json(); } catch {
        if (requestController.signal.aborted) throw requestController.signal.reason || new DOMException('Aborted','AbortError');
        throw catalogError('The fast wheel catalog is not available in this theme yet.');
      }
      return data;
    } catch(error) {
      if (timedOut) throw catalogError('Loading the wheel catalog took too long. Please try again.');
      throw error;
    } finally {
      clearTimeout(timer);
      controller.signal.removeEventListener('abort',cancelRequest);
    }
  };
  const collectionUrl = page=>{const u = new URL(base);u.searchParams.set('page',String(page));return u;};
  try {
    if (controller.signal.aborted) throw controller.signal.reason || new DOMException('Aborted','AbortError');
    if (cacheKey && force) {
      await catalogCacheOperation('delete-scope', {key:cacheKey}, controller.signal);
      if (controller.signal.aborted) throw controller.signal.reason || new DOMException('Aborted','AbortError');
    }
    if (cacheKey && !force) {
      const saved = await catalogCacheOperation('read', null, controller.signal);
      if (controller.signal.aborted) throw controller.signal.reason || new DOMException('Aborted','AbortError');
      if (saved && saved.key === cacheKey) {
        try {
          catalogAssert(catalogCacheRecordValid(saved, cacheKey, expectedCurrency));
          validateFastCatalogPage(saved.pages.find(page => page?.page === 1), 1, handle);
          const normalized = normalizeFastCatalogPages(saved.pages, new Map(saved.overflow), base.origin);
          catalogAssert(normalized.currency === expectedCurrency);
          if (controller.signal.aborted) throw controller.signal.reason || new DOMException('Aborted','AbortError');
          return {...normalized, checkedAt:saved.checkedAt, requestCount:0, cacheHit:true};
        } catch {
          await catalogCacheOperation('delete', saved, controller.signal);
          if (controller.signal.aborted) throw controller.signal.reason || new DOMException('Aborted','AbortError');
        }
      }
    }
    checkedAt = new Date().toISOString();
    const first = validateFastCatalogPage(await get(collectionUrl(1)),1,handle);
    catalogAssert(expectedCurrency === undefined || first.currency === expectedCurrency, 'The store currency changed. Please reload and try again.');
    totalPages=first.pages;totalProducts=first.totalProducts;loadedPages=1;productsChecked=first.products.length;progress('catalog');
    const rest = await catalogPool(Array.from({length:first.pages-1},(_,i)=>i+2),async page=>{
      const p=validateFastCatalogPage(await get(collectionUrl(page)),page,handle);
      loadedPages++;productsChecked+=p.products.length;progress('catalog');return p;
    });
    const pages=[first,...rest],overflow = new Map();
    const incomplete=pages.flatMap(p=>p.products.filter(product=>product.variants.length<product.variantsCount));
    // Rare high-variant products are read independently in complete 50-variant pages.
    // Do not use the truncated initial list as if it were a whole product.
    for (const product of incomplete) {
      const productUrl = page=>{const u = new URL(base);u.pathname=localePrefix+'/products/'+product.handle;u.searchParams.set('page',String(page));return u;};
      const p1=validateFastProductPage(await get(productUrl(1)),1,product,first.currency);progress('variants');
      const remaining=await catalogPool(Array.from({length:p1.pages-1},(_,i)=>i+2),async page=>{
        const p=validateFastProductPage(await get(productUrl(page)),page,product,first.currency);progress('variants');return p;
      });
      overflow.set(product.id,[p1,...remaining]);
    }
    const normalized=normalizeFastCatalogPages(pages,overflow,base.origin);
    if (controller.signal.aborted) throw controller.signal.reason || new DOMException('Aborted','AbortError');
    if (cacheKey) {
      const record = {schema:FAST_CATALOG_CACHE_SCHEMA, key:cacheKey, currency:normalized.currency, checkedAt, freshnessAt:Date.parse(checkedAt), pages, overflow:Array.from(overflow)};
      // Raw pages avoid repeated product metadata in the normalized variant list.
      try {
        const bytes = new TextEncoder().encode(JSON.stringify(record)).byteLength;
        if (bytes <= FAST_CATALOG_CACHE_MAX_BYTES && Date.now() - record.freshnessAt < FAST_CATALOG_CACHE_TTL) await catalogCacheOperation('write', record, controller.signal);
      } catch {}
    }
    if (controller.signal.aborted) throw controller.signal.reason || new DOMException('Aborted','AbortError');
    return {...normalized,checkedAt,requestCount,cacheHit:false};
  } catch(error) { controller.abort(); throw error; }
  finally { signal?.removeEventListener('abort',abort); }
}





(function () {
  'use strict';
  var PARAMS = ['year', 'make', 'model', 'trim', 'modification'];
  var KEYS = ['year', 'make', 'model', 'modification'];
  var HIDDEN_MAKES = ['abarth', 'bmwalpina', 'bugatti', 'ferrari', 'panoz', 'morgan', 'mosler', 'byd', 'fisker', 'ineos', 'lotus', 'mahindra', 'polaris', 'seres', 'vinfast'];
  function asUrl(value) {
    try { return new URL(value === undefined ? window.location.href : String(value), window.location.href); }
    catch (_) { return null; }
  }
  function canonical(value) {
    if (!value || typeof value !== 'object') return null;
    var result = {};
    for (var i = 0; i < KEYS.length; i++) {
      var key = KEYS[i], part = value[key];
      if (typeof part !== 'string' && !(key === 'year' && typeof part === 'number')) return null;
      part = String(part);
      if (key === 'year') {
        if (!/^\d{4}$/.test(part) || Number(part) < 1950 || Number(part) > new Date().getFullYear() + 1) return null;
      } else {
        if (!/^[a-z0-9][a-z0-9_-]{0,239}$/i.test(part)) return null;
        part = part.toLowerCase();
      }
      result[key] = part;
    }
    if (HIDDEN_MAKES.includes(result.make.replace(/[^a-z0-9]/g, ''))) return null;
    return result;
  }
  function validTrim(value) {
    return typeof value === 'string' && value.length > 0 && value.length <= 240 && !/[\u0000-\u001f\u007f]/.test(value);
  }
  function has(value) {
    var url = asUrl(value);
    return Boolean(url && PARAMS.some(function (key) { return url.searchParams.has(key); }));
  }
  function read(value) {
    var url = asUrl(value);
    if (!url || PARAMS.some(function (key) { return url.searchParams.getAll(key).length > 1; })) return null;
    if (url.searchParams.has('trim') && !validTrim(url.searchParams.get('trim'))) return null;
    var input = {};
    KEYS.forEach(function (key) { input[key] = url.searchParams.get(key); });
    return canonical(input);
  }
  function withVehicle(detail, value) {
    var url = asUrl(value), vehicle = canonical(detail && detail.vehicle);
    if (!url || !vehicle) return null;
    var trim = detail && detail.labels && detail.labels.modification;
    if (trim !== undefined && !validTrim(trim)) return null;
    PARAMS.forEach(function (key) { url.searchParams.delete(key); });
    KEYS.forEach(function (key) { url.searchParams.set(key, vehicle[key]); });
    if (trim !== undefined) url.searchParams.set('trim', trim);
    return url;
  }
  function commit(url, options) {
    if (!url || url.origin !== window.location.origin) return null;
    try {
      var method = options && options.replace === false ? 'pushState' : 'replaceState';
      window.history[method](window.history.state, '', url.href);
      return url;
    } catch (_) { return null; }
  }
  function write(detail, options) { return commit(withVehicle(detail), options); }
  function clear(options) {
    var url = asUrl();
    if (!url) return null;
    PARAMS.forEach(function (key) { url.searchParams.delete(key); });
    return commit(url, options);
  }
  window.WOVehicleUrl = Object.freeze({ read: read, has: has, withVehicle: withVehicle, write: write, clear: clear });
})();
(function () {
  'use strict';
  var STRINGS = {
    year: 'Year', make: 'Make', model: 'Model', modification: 'Trim',
    select_year: 'Select year', select_make: 'Select make', select_model: 'Select model', select_modification: 'Select trim',
    submit: 'Search wheels', retry: 'Try again', reset: 'Reset', reset_label: 'Reset vehicle selection',
    ready: 'Select your vehicle to find wheel options.',
    saved: 'Your saved vehicle is selected. You can change any selection.',
    selected: 'Selected trim: {trim}. Search for wheel options.',
    loading_make: 'Loading makes…', loading_model: 'Loading models…', loading_modification: 'Loading trims…',
    choose_make: 'Choose your make.', choose_model: 'Choose your model.', choose_modification: 'Choose your trim.',
    empty_make: 'No makes were found for this year. Choose another year.',
    empty_model: 'No models were found for this selection. Choose another make.',
    empty_modification: 'No trims were found for this selection. Choose another model.',
    retry_seconds: 'Please wait {seconds} seconds before trying again.',
    rate_limited: 'Please wait a moment before trying again.',
    unavailable: 'Vehicle search is temporarily unavailable. Please try again later.',
    unreadable: 'The vehicle list could not be read. Please try again.',
    failed: 'The vehicle list could not be loaded. Please try again.',
    connection: 'We could not connect. Check your connection and try again.',
    timeout: 'The request took too long. Please try again.',
    incomplete: 'Complete the vehicle selection before searching.'
  };
  var SELECTED_KEY = 'wo-fitment:selected-vehicle:v1';
  var LISTS_KEY = 'wo-fitment:vehicle-lists:v2';
  var ENDPOINT = 'https://wheelsoutlet-fitment.rock-4d1.workers.dev/storefront-api';
  var KEYS = ['year', 'make', 'model', 'modification'];
  var STEPS = { make: 'makes', model: 'models', modification: 'modifications' };

  function hiddenMake(value, label) {
    return [value, label].some(function (part) {
      var name = String(part ?? '').normalize('NFKC').toLowerCase().replace(/[^a-z0-9]/g, '');
      return ['abarth', 'bmwalpina', 'bugatti', 'ferrari', 'panoz', 'morgan', 'mosler', 'byd', 'fisker', 'ineos', 'lotus', 'mahindra', 'polaris', 'seres', 'vinfast'].includes(name);
    });
  }
  function node(tag, className, text) {
    var result = document.createElement(tag);
    if (className) result.className = 'wo-vehicle-picker__' + className;
    if (text !== undefined) result.textContent = String(text);
    return result;
  }
  function initialize(root) {
    if (root.dataset.woVehiclePickerInitialized === 'true') return;
    root.dataset.woVehiclePickerInitialized = 'true';
    root.classList.add('wo-vehicle-picker');
    var overrides = {};
    try {
      var localeNode = root.querySelector('script[type="application/json"][data-wo-vehicle-picker-i18n]');
      if (localeNode) overrides = JSON.parse(localeNode.textContent) || {};
    } catch (_) {}
    function t(key, values) {
      var text = typeof overrides[key] === 'string' ? overrides[key] : STRINGS[key] || key;
      return text.replace(/\{([a-zA-Z0-9_]+)\}/g, function (token, name) { return values && values[name] !== undefined ? String(values[name]) : token; });
    }
    var endpoint;
    try {
      endpoint = new URL(root.dataset.endpoint || ENDPOINT);
      if (endpoint.protocol !== 'https:') throw new Error('Invalid endpoint');
    } catch (_) { root.replaceChildren(node('p', 'error', t('unavailable'))); return; }
    var state = { sequence: 0, interactionVersion: 0, pending: null, retry: null, loadedFor: {}, cache: {}, urlVehicle: null };
    var ui = { fields: {} };
    try {
      var savedCache = JSON.parse(sessionStorage.getItem(LISTS_KEY) || '{}');
      if (savedCache && typeof savedCache === 'object' && !Array.isArray(savedCache)) state.cache = savedCache;
    } catch (_) {}
    ui.form = node('form', 'form');
    KEYS.forEach(function (key) {
      var label = node('label', 'field');
      var select = node('select', 'select');
      select.name = key;
      select.setAttribute('aria-label', t(key));
      select.dataset.woField = key;
      label.append(node('span', 'label', t(key)), select);
      ui.form.append(label);
      ui.fields[key] = select;
    });
    ui.submit = node('button', 'submit', t('submit'));
    ui.submit.type = 'submit';
    ui.reset = node('button', 'reset', t('reset')); ui.reset.type = 'button';
    ui.reset.setAttribute('aria-label', t('reset_label'));
    var action = node('div', 'action'); action.append(ui.submit, ui.reset); ui.form.append(action);
    ui.status = node('p', 'status', t('ready'));
    ui.status.setAttribute('role', 'status');
    ui.status.setAttribute('aria-live', 'polite');
    ui.status.setAttribute('aria-atomic', 'true');
    ui.error = node('div', 'error');
    ui.error.hidden = true;
    ui.error.setAttribute('role', 'alert');
    ui.errorText = node('p');
    ui.retry = node('button', 'retry', t('retry'));
    ui.retry.type = 'button';
    ui.error.append(ui.errorText, ui.retry);
    root.replaceChildren(ui.form, ui.status, ui.error);

    function selected() {
      var result = {};
      KEYS.forEach(function (key) { result[key] = ui.fields[key].value; });
      return result;
    }
    function selectedLabels() {
      var result = {};
      KEYS.forEach(function (key) { result[key] = ui.fields[key].selectedOptions[0]?.textContent || ''; });
      return result;
    }
    function currentMakeHidden() { return hiddenMake(ui.fields.make.value, ui.fields.make.selectedOptions[0]?.textContent); }
    function complete() {
      return !currentMakeHidden() && KEYS.every(function (key) { return Boolean(ui.fields[key].value) && (!state.urlVehicle || ui.fields[key].value === state.urlVehicle[key]); }) &&
        KEYS.slice(1).every(function (key) { return state.loadedFor[key] === cacheKey(key); });
    }
    function selectedStatus() { return t('selected', { trim: selectedLabels().modification }); }
    function parentsPresent(key) { return KEYS.slice(0, KEYS.indexOf(key)).every(function (parent) { return Boolean(ui.fields[parent].value); }); }
    function cacheKey(key) {
      return JSON.stringify([key].concat(KEYS.slice(0, KEYS.indexOf(key)).map(function (parent) { return ui.fields[parent].value; })));
    }
    function sync() {
      KEYS.forEach(function (key) {
        ui.fields[key].disabled = key !== 'year' && (!parentsPresent(key) || ui.fields[key].options.length < 2);
      });
      ui.submit.disabled = Boolean(state.pending) || !complete();
      ui.retry.disabled = Boolean(state.pending);
      ui.form.setAttribute('aria-busy', String(Boolean(state.pending)));
    }
    function reset(key) {
      var option = node('option', '', t('select_' + key)); option.value = '';
      ui.fields[key].replaceChildren(option);
      delete state.loadedFor[key];
    }
    function clearAfter(key) { KEYS.slice(KEYS.indexOf(key) + 1).forEach(reset); }
    function clearSaved() { try { sessionStorage.removeItem(SELECTED_KEY); } catch (_) {} }
    function saveSelected() {
      // Shared URLs must resolve to real list labels before becoming a saved selection.
      if (state.urlVehicle && !complete()) { clearSaved(); return; }
      // Keep ordinary saved labels and slugs during list validation.
      if (currentMakeHidden() || !KEYS.every(function (key) { return Boolean(ui.fields[key].value); })) { clearSaved(); return; }
      var values = selected(), labels = selectedLabels(), data = {};
      KEYS.forEach(function (key) { data[key] = { value: values[key], label: labels[key] }; });
      try { sessionStorage.setItem(SELECTED_KEY, JSON.stringify(data)); } catch (_) {}
    }
    function normalize(choices, preserveOrder, filterMakes) {
      var seen = new Set(), result = [];
      (Array.isArray(choices) ? choices : []).forEach(function (item) {
        var isObject = item && typeof item === 'object';
        var value = isObject ? item.value ?? item.slug ?? item.id ?? item.name : item;
        var label = isObject ? item.label ?? item.name ?? item.title ?? value : item;
        if (value === null || value === undefined || String(value) === '' || seen.has(String(value))) return;
        if (filterMakes && hiddenMake(value, label)) return;
        seen.add(String(value));
        result.push({ value: String(value), label: String(label) });
      });
      if (!preserveOrder) result.sort(function (a, b) { return a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' }); });
      return result;
    }
    function cached(key) {
      var items = state.cache[cacheKey(key)];
      if (!Array.isArray(items) || !items.every(function (item) { return item && typeof item.value === 'string' && typeof item.label === 'string'; })) return null;
      return normalize(items, key === 'modification', key === 'make');
    }
    function remember(key, choices) {
      var id = cacheKey(key);
      delete state.cache[id]; state.cache[id] = choices;
      var entries = Object.keys(state.cache);
      while (entries.length > 24) delete state.cache[entries.shift()];
      try { sessionStorage.setItem(LISTS_KEY, JSON.stringify(state.cache)); } catch (_) {}
    }
    function fill(key, choices, value) {
      reset(key);
      choices.forEach(function (choice) { var option = node('option', '', choice.label); option.value = choice.value; ui.fields[key].append(option); });
      if (value && choices.some(function (choice) { return choice.value === value; })) ui.fields[key].value = value;
      else if (key === 'modification' && choices.length && !state.urlVehicle) ui.fields[key].value = choices[0].value;
      state.loadedFor[key] = cacheKey(key);
    }
    function fillYears() {
      reset('year');
      var last = new Date().getFullYear() + 1;
      for (var year = last; year >= 1950; year--) { var option = node('option', '', year); option.value = String(year); ui.fields.year.append(option); }
    }
    function restore() {
      try {
        var data;
        var urlHelper = window.WOVehicleUrl;
        var hasVehicleUrl = urlHelper ? urlHelper.has() : ['year', 'make', 'model', 'trim', 'modification'].some(function (key) { return new URLSearchParams(window.location.search).has(key); });
        if (hasVehicleUrl) {
          // Even an invalid or partial link takes precedence over an unrelated saved vehicle.
          clearSaved();
          state.urlVehicle = urlHelper ? urlHelper.read() : null;
          if (!state.urlVehicle) { ui.status.textContent = t('incomplete'); return; }
          data = {};
          KEYS.forEach(function (key) { data[key] = { value: state.urlVehicle[key], label: state.urlVehicle[key] }; });
        } else data = JSON.parse(sessionStorage.getItem(SELECTED_KEY) || 'null');
        if (hiddenMake(data?.make?.value, data?.make?.label)) { clearSaved(); return; }
        if (!data || !KEYS.every(function (key) { return typeof data[key]?.value === 'string' && data[key].value.length > 0 && data[key].value.length <= 240 && typeof data[key]?.label === 'string' && data[key].label.length <= 240; })) return;
        if (!Array.from(ui.fields.year.options).some(function (option) { return option.value === data.year.value; })) return;
        ui.fields.year.value = data.year.value;
        KEYS.slice(1).forEach(function (key) {
          if (!parentsPresent(key)) return;
          var choices = cached(key);
          if (choices) {
            fill(key, choices, data[key].value);
            if (ui.fields[key].value !== data[key].value) {
              ui.fields[key].value = ''; clearAfter(key); clearSaved();
              root.dispatchEvent(new CustomEvent('wo:vehicle-invalid', { bubbles: true }));
            }
          }
          else {
            var option = node('option', '', data[key].label);
            option.value = data[key].value;
            ui.fields[key].append(option); ui.fields[key].value = data[key].value;
          }
        });
        // Saved selections remain unverified until their current parent lists are loaded.
        if (complete()) ui.status.textContent = selectedStatus();
        else if (state.urlVehicle) ui.status.textContent = t('incomplete');
        saveSelected();
      } catch (_) {}
    }
    function stopPending() {
      state.sequence++;
      if (state.pending) state.pending.controller.abort();
      state.pending = null;
      state.retry = null;
      ui.error.hidden = true;
    }
    async function request(step, signal) {
      var controller = new AbortController(), timedOut = false;
      function abort() { controller.abort(); }
      if (signal.aborted) throw new DOMException('Cancelled', 'AbortError');
      signal.addEventListener('abort', abort, { once: true });
      var timer = setTimeout(function () { timedOut = true; controller.abort(); }, 30000);
      try {
        var response = await fetch(endpoint.href, {
          method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(Object.assign({ step: step }, selected())), signal: controller.signal
        });
        if (response.status === 401 || response.status === 403) throw new Error(t('unavailable'));
        if (response.status === 429) {
          var seconds = Number(response.headers.get('Retry-After'));
          throw new Error(Number.isFinite(seconds) && seconds > 0 && seconds <= 3600 ? t('retry_seconds', { seconds: Math.ceil(seconds) }) : t('rate_limited'));
        }
        var data;
        try { data = await response.json(); } catch (_) { throw new Error(t('unreadable')); }
        if (!response.ok || !data || data.error) {
          var message = typeof data?.error === 'string' ? data.error : data?.error?.message;
          throw new Error(message || t('failed'));
        }
        if (!Array.isArray(data.choices)) throw new Error(t('unreadable'));
        return normalize(data.choices, step === 'modifications', step === 'makes');
      } catch (error) {
        if (timedOut) throw new Error(t('timeout'));
        if (error instanceof TypeError) throw new Error(t('connection'));
        throw error;
      } finally { clearTimeout(timer); signal.removeEventListener('abort', abort); }
    }
    async function load(key, preserve) {
      if (!parentsPresent(key)) return;
      var id = cacheKey(key), value = preserve ? ui.fields[key].value : '';
      if (state.loadedFor[key] === id) return;
      if (state.pending?.key === key && state.pending.id === id) return;
      stopPending();
      if (key === 'modification' && !preserve) { reset(key); clearSaved(); }
      var sequence = state.sequence;
      var choices = cached(key);
      if (choices) {
        fill(key, choices, value);
        if (value && !ui.fields[key].value) { clearAfter(key); clearSaved(); root.dispatchEvent(new CustomEvent('wo:vehicle-invalid', { bubbles: true })); }
        ui.status.textContent = complete() ? selectedStatus() : t(choices.length ? 'choose_' + key : 'empty_' + key);
        saveSelected(); sync(); return;
      }
      var controller = new AbortController();
      state.pending = { key: key, id: id, controller: controller };
      ui.status.textContent = t('loading_' + key); sync();
      try {
        choices = await request(STEPS[key], controller.signal);
        if (controller.signal.aborted || sequence !== state.sequence || id !== cacheKey(key)) return;
        remember(key, choices);
        fill(key, choices, value);
        if (value && !ui.fields[key].value) { clearAfter(key); clearSaved(); root.dispatchEvent(new CustomEvent('wo:vehicle-invalid', { bubbles: true })); }
        ui.status.textContent = complete() ? selectedStatus() : t(choices.length ? 'choose_' + key : 'empty_' + key);
        saveSelected();
      } catch (error) {
        if (sequence !== state.sequence || error.name === 'AbortError') return;
        ui.errorText.textContent = error.message || t('failed'); ui.error.hidden = false;
        ui.status.textContent = t('failed'); state.retry = async function () {
          var version = state.interactionVersion;
          await load(key, preserve);
          if (preserve && version === state.interactionVersion && state.loadedFor[key] === cacheKey(key)) hydrateSavedLists();
        };
      } finally {
        if (sequence === state.sequence) { state.pending = null; sync(); }
      }
    }
    async function hydrateSavedLists() {
      // Catalog lists are cacheable; this never performs a vehicle fitment Search.
      var version = state.interactionVersion;
      for (var i = 1; i < KEYS.length; i++) {
        var key = KEYS[i];
        if (version !== state.interactionVersion || !parentsPresent(key)) return;
        if (state.loadedFor[key] === cacheKey(key)) continue;
        await load(key, true);
        if (version !== state.interactionVersion || state.loadedFor[key] !== cacheKey(key)) return;
      }
    }
    function changed(key) {
      state.urlVehicle = null;
      state.interactionVersion++;
      stopPending(); clearAfter(key); clearSaved(); sync();
      if (!ui.fields[key].value) { ui.status.textContent = t('ready'); return; }
      var index = KEYS.indexOf(key);
      if (index === KEYS.length - 1) {
        saveSelected(); ui.status.textContent = selectedStatus(); sync();
        if (!complete()) hydrateSavedLists();
        return;
      }
      load(KEYS[index + 1], false);
    }
    KEYS.forEach(function (key) {
      ui.fields[key].addEventListener('change', function () { changed(key); });
      if (key !== 'year') {
        function ensureChoices() { if (!state.pending && parentsPresent(key) && state.loadedFor[key] !== cacheKey(key)) load(key, true); }
        ui.fields[key].addEventListener('focus', ensureChoices);
        ui.fields[key].addEventListener('pointerdown', ensureChoices);
      }
    });
    ui.form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (state.pending || !complete()) { ui.status.textContent = t('incomplete'); return; }
      saveSelected();
      var labels = selectedLabels();
      root.dispatchEvent(new CustomEvent('wo:vehicle-submit', {
        bubbles: true, composed: true, cancelable: true,
        detail: { vehicle: selected(), label: KEYS.map(function (key) { return labels[key]; }).join(' '), labels: labels }
      }));
    });
    document.addEventListener('wo:vehicle-reset', function () {
      if (!root.isConnected) return;
      state.urlVehicle = null; state.interactionVersion++; stopPending(); clearSaved();
      fillYears(); KEYS.slice(1).forEach(reset); ui.errorText.textContent = '';
      ui.status.textContent = t('ready'); sync();
    });
    ui.reset.addEventListener('click', function () {
      root.dispatchEvent(new CustomEvent('wo:vehicle-reset', { bubbles: true, composed: true }));
      ui.fields.year.focus();
    });
    ui.retry.addEventListener('click', function () { if (!state.pending && state.retry) state.retry(); });
    KEYS.forEach(reset); fillYears(); restore(); sync();
    if (ui.fields.year.value && ui.fields.make.value) hydrateSavedLists();
  }
  function initializeWithin(root) {
    if (root.matches?.('[data-wo-vehicle-picker]')) initialize(root);
    root.querySelectorAll('[data-wo-vehicle-picker]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
})();
(function () {
  'use strict';
  if (window.__woVehicleResultsInstalled) return;
  window.__woVehicleResultsInstalled = true;
  var STRINGS = {
    title: 'Wheels for your vehicle', ready: 'Choose your vehicle and search to see suggested wheels.',
    notice: 'Suggested fitment only. Center bore is not compared; brake clearance and load rating need confirmation before ordering. Availability is per wheel, not a confirmed set of four.',
    checking: 'Checking your vehicle and wheel availability…', checking_catalog: 'Checking wheel availability…',
    complete: 'Availability checked {date}.', cancelled: 'Search cancelled. Search again when you are ready.',
    changed: 'Vehicle changed. Search to update your wheel suggestions.',
    retry: 'Try again', cancel: 'Cancel', refresh: 'Refresh availability',
    error: 'The search could not finish. Please try again.', timeout: 'The vehicle request took too long. Please try again.',
    unavailable: 'Vehicle search is temporarily unavailable. Please try again later.',
    connection: 'We could not connect. Check your connection and try again.',
    rate_limited: 'Please wait a moment before trying again.', retry_seconds: 'Please wait {seconds} seconds before trying again.',
    invalid_vehicle: 'Choose a complete vehicle selection before searching.',
    exact_vehicle: 'Choose an exact supported vehicle trim to see wheel suggestions.',
    unsupported_vehicle: 'No supported wheel reference was found for this trim. Choose another vehicle.',
    catalog_error: 'Current wheel availability could not be confirmed. Please try again.',
    comparison_error: 'The wheel comparison is temporarily unavailable. Please try again later.',
    expired: 'Choose Search wheels to check this vehicle. Your previous search has expired.',
    storage_error: 'Your browser could not save the vehicle selection. Please enable session storage and try again.',
    filters: 'Filters', brand: 'Brand', diameter: 'Diameter', finish: 'Finish', clear_filters: 'Clear filters',
    all_diameters: 'All diameters', selected_diameters: '{count} selected',
    sort: 'Sort by', featured: 'Featured', price_low: 'Price: low to high', price_high: 'Price: high to low', diameter_sort: 'Diameter',
    products_one: '{count} wheel', products_other: '{count} wheels',
    vehicle_heading: 'Suggested wheels for {vehicle}',
    no_results: 'No suggested wheels were found for this vehicle. Try another selection or contact us for fitment help.',
    no_filter_results: 'No wheels match these filters. Try another brand, diameter or finish.',
    price_filtered: 'Some prices could not be confirmed in {currency} and are not shown.',
    price_unit: '{currency} per wheel', available: 'Available to order', backorder: 'Available to backorder',
    image_unavailable: 'Image unavailable', finish_unknown: 'Finish unavailable', other_brand: 'Other',
    show_finish: 'Show {finish}', wheel: 'Wheel', wheel_image: '{title} — {finish}',
    size: '{diameter}x{width} {pcd} ET{offset}', diameter_value: '{diameter} inch',
    plus_size: 'Plus size — check tire size',
    previous: 'Previous', next: 'Next', page: 'Page {page} of {pages}', pagination: 'Wheel results pages',
    axle: 'Wheel position', front_wheels: 'Front wheels', rear_wheels: 'Rear wheels', front_axle: 'Front axle', rear_axle: 'Rear axle',
    staggered_note: 'Choose front and rear wheels separately. Prices are per wheel.',
    no_axle_results: 'No suggested wheels were found for the {axle}. Try the other position or contact us for fitment help.',
    just_checked: 'just checked', view_wheel: 'View {title}, {finish}, {size}'
  };
  var INTENT_KEY = 'wo-fitment:search-intent:v2';
  var RESULTS_KEY = 'wo-fitment:completed-search:v1', RESULT_TTL = 86400000;
  function discardResults() { try { sessionStorage.removeItem(RESULTS_KEY); } catch (_) {} }
  var INTENT_TTL = 60000, CACHE_TTL = 300000, PAGE_SIZE = 25;
  var ENDPOINT = 'https://wheelsoutlet-fitment.rock-4d1.workers.dev/storefront-api';
  var KEYS = ['year', 'make', 'model', 'modification'];
  var activeController = null;
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  }
  function blockedMake(value) {
    return typeof value === 'string' && ['abarth', 'bmwalpina', 'bugatti', 'ferrari', 'panoz', 'morgan', 'mosler', 'byd', 'fisker', 'ineos', 'lotus', 'mahindra', 'polaris', 'seres', 'vinfast'].includes(value.normalize('NFKC').toLowerCase().replace(/[^a-z0-9]/g, ''));
  }
  function validDetail(detail) {
    if (!detail || !detail.vehicle || !KEYS.every(function (key) { return typeof detail.vehicle[key] === 'string' && detail.vehicle[key].length > 0 && detail.vehicle[key].length <= 240; })) return null;
    if (blockedMake(detail.vehicle.make) || blockedMake(detail.labels?.make)) return null;
    var vehicle = {}, labels = {};
    KEYS.forEach(function (key) { vehicle[key] = detail.vehicle[key]; labels[key] = typeof detail.labels?.[key] === 'string' ? detail.labels[key].slice(0, 240) : vehicle[key]; });
    return { vehicle: vehicle, labels: labels, label: typeof detail.label === 'string' && detail.label.trim() ? detail.label.slice(0, 1000) : KEYS.map(function (key) { return labels[key]; }).join(' ') };
  }
  // Collection membership is the scope; vendor names can cover several wheel brands.
  function collectionTarget(value) {
    var target = new URL(value, location.origin);
    if (typeof value !== 'string' || !value.trim() || target.origin !== location.origin || target.username || target.password || target.search || target.hash ||
        !/^(?:\/[a-z]{2}(?:-[A-Za-z]{2})?)?\/collections\/[a-z0-9][a-z0-9-]*\/?$/.test(target.pathname)) throw new Error('Invalid collection scope');
    target.pathname = target.pathname.replace(/\/$/, '');
    return target;
  }
  function usableReference(reference, referenceAt) {
    var now = Date.now();
    if (!reference || typeof reference !== 'object' || Array.isArray(reference) ||
        !Number.isFinite(referenceAt) || referenceAt > now || now - referenceAt >= RESULT_TTL) return false;
    function dimensions(value) {
      return value && typeof value === 'object' && !Array.isArray(value) &&
        value.staggered !== true && value.setup !== 'staggered' &&
        scalarSpec(value.diameter) > 0 && scalarSpec(value.width) > 0 && scalarSpec(value.offset) !== null;
    }
    if (reference.wheels !== undefined && (!Array.isArray(reference.wheels) ||
        !reference.wheels.every(dimensions))) return false;
    if (reference.axleReferences !== undefined && !Array.isArray(reference.axleReferences)) return false;
    var seen = new Set(), pairs = reference.axleReferences || [];
    if (!pairs.every(function (pair) {
      if (!pair || typeof pair !== 'object' || Array.isArray(pair) ||
          typeof pair.id !== 'string' || !pair.id.trim() || pair.id.length > 240 || seen.has(pair.id) ||
          !['square', 'staggered'].includes(pair.setup) || !dimensions(pair.front) || !dimensions(pair.rear) ||
          !canonicalPattern(pair.front.boltPattern) || !canonicalPattern(pair.rear.boltPattern)) return false;
      seen.add(pair.id); return true;
    })) return false;
    var staggered = pairs.some(function (pair) {
      return pair.setup === 'staggered' || ['diameter', 'width', 'offset'].some(function (key) {
        return scalarSpec(pair.front[key]) !== scalarSpec(pair.rear[key]);
      }) || canonicalPattern(pair.front.boltPattern) !== canonicalPattern(pair.rear.boltPattern);
    });
    return staggered ? pairs.length > 0 :
      Boolean(canonicalPattern(reference.boltPattern) && reference.wheels?.length > 0);
  }
  var VEHICLE_REFERENCE_KEY = 'wo-fitment:vehicle-reference:v1';
  function discardVehicleReference() { try { sessionStorage.removeItem(VEHICLE_REFERENCE_KEY); } catch (_) {} }
  function referenceScope(root) {
    var shopify = window.Shopify, theme = String(shopify?.theme?.id || '');
    var currency = root?.dataset.currency || shopify?.currency?.active || 'USD';
    var locale = root?.lang || document.documentElement.lang || navigator.language || 'en';
    if (!/^[1-9]\d*$/.test(theme) || !/^[A-Z]{3}$/.test(currency) || shopify?.currency?.active && shopify.currency.active !== currency) return null;
    try {
      var endpoint = new URL(root?.dataset.endpoint || ENDPOINT);
      if (endpoint.protocol !== 'https:') return null;
      return JSON.stringify(['wo-vehicle-reference-v1', location.origin, endpoint.href, theme,
        String(shopify?.theme?.role || ''), currency, String(shopify?.locale || locale),
        String(shopify?.country || ''), String(shopify?.routes?.root || '/')]);
    } catch (_) { return null; }
  }
  function vehiclesMatch(left, right) { return Boolean(left && right && KEYS.every(function (key) { return left[key] === right[key]; })); }
  function readVehicleReference(root) {
    try {
      var raw = sessionStorage.getItem(VEHICLE_REFERENCE_KEY), scope = referenceScope(root);
      if (!raw || raw.length > 262144 || !scope) return null;
      var record = JSON.parse(raw), detail = validDetail(record?.detail);
      if (record?.schema !== 'wo-vehicle-reference-v1' || record.scope !== scope || !detail ||
          !window.WOVehicleUrl?.withVehicle(detail) || !usableReference(record.reference, record.referenceAt)) return null;
      return { detail: detail, reference: record.reference, referenceAt: record.referenceAt };
    } catch (_) { return null; }
  }
  function referenceForCurrentVehicle(root) {
    var record = readVehicleReference(root);
    if (!record) return null;
    if (window.WOVehicleUrl?.has() && !vehiclesMatch(window.WOVehicleUrl.read(), record.detail.vehicle)) {
      discardVehicleReference(); return null;
    }
    return record;
  }
  function resumeBrandLanding(root) {
    if (document.querySelector('[data-wo-vehicle-results]') || !root.hasAttribute('data-wo-collection-url')) return;
    var current = new URL(location.href), target;
    if (current.searchParams.has('intent') || current.searchParams.has('wo_browse') ||
        current.searchParams.has('view') || Array.from(current.searchParams.keys()).some(function (key) { return /^(filter\.|page$|sort_by$|q$)/.test(key); })) return;
    try { target = collectionTarget(root.dataset.woCollectionUrl); } catch (_) { return; }
    if (target.pathname !== current.pathname.replace(/\/$/, '') || /\/collections\/(wheels|all)$/.test(target.pathname)) return;
    var record = referenceForCurrentVehicle(root);
    if (!record) return;
    target = window.WOVehicleUrl.withVehicle(record.detail, target);
    if (!target) return;
    target.searchParams.set('view', 'vehicle');
    var preview = current.searchParams.get('preview_theme_id'); if (preview) target.searchParams.set('preview_theme_id', preview);
    // Continue the completed vehicle comparison with this brand's catalog; never create a Search intent.
    location.replace(target.pathname + target.search);
  }
  function initialize(root) {
    if (root.dataset.woVehicleResultsInitialized === 'true') return;
    root.dataset.woVehicleResultsInitialized = 'true';
    root.classList.add('wo-vehicle-results');
    root.dataset.woResultsState = 'idle';
    var overrides = {};
    try { var dictionary = root.querySelector('script[type="application/json"][data-wo-vehicle-results-i18n]'); if (dictionary) overrides = JSON.parse(dictionary.textContent) || {}; } catch (_) {}
    function t(key, values) {
      var text = typeof overrides[key] === 'string' ? overrides[key] : STRINGS[key] || key;
      return text.replace(/\{([a-zA-Z0-9_]+)\}/g, function (token, name) { return values && values[name] !== undefined ? String(values[name]) : token; });
    }
    var locale = root.lang || document.documentElement.lang || navigator.language || 'en';
    var currency = /^[A-Z]{3}$/.test(root.dataset.currency || '') ? root.dataset.currency : 'USD';
    var endpoint;
    try { endpoint = new URL(root.dataset.endpoint || ENDPOINT); if (endpoint.protocol !== 'https:') throw new Error(); }
    catch (_) { root.replaceChildren(el('p', 'wo-vehicle-error', t('unavailable'))); return; }
    var entryUrl = new URL(location.href), entryVehicle = window.WOVehicleUrl?.read(entryUrl);
    var catalogUrl, catalogVendor;
    try {
      if (root.hasAttribute('data-catalog-url')) {
        catalogUrl = collectionTarget(root.dataset.catalogUrl);
        if (catalogUrl.pathname !== entryUrl.pathname.replace(/\/$/, '')) throw new Error('Mismatched collection scope');
        catalogUrl = catalogUrl.href;
      }
      if (root.hasAttribute('data-catalog-vendor')) {
        catalogVendor = String(root.dataset.catalogVendor || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        if (!catalogUrl || !catalogVendor) throw new Error('Invalid collection brand');
      }
    } catch (_) {
      root.dataset.woResultsState = 'error';
      root.replaceChildren(el('p', 'wo-vehicle-error', t('catalog_error'))); return;
    }
    var entryAxles = entryUrl.searchParams.getAll('axle');
    var preferredAxle = entryVehicle && entryAxles.length === 1 && ['front', 'rear'].includes(entryAxles[0])
      ? { vehicle: entryVehicle, axle: entryAxles[0] } : null;
    var s = { sequence: 0, controller: null, busy: false, last: null, lastForce: false, vehicleRef: null, refKey: null, referenceAt: null, lastResume: null, matches: [], allMatches: [], staggered: false, axle: 'front', groups: [], page: 1, memo: null, checkedAt: null, sort: 'featured', filters: { brand: new Set(), diameter: new Set(), finish: new Set() }, priceRejected: 0 };
    var ui = {};
    var header = el('div', 'wo-vehicle-results-heading');
    ui.title = el('h2', '', t('title')); ui.title.hidden = true;
    ui.vehicle = el('p', 'wo-vehicle-summary');
    header.append(ui.title, ui.vehicle);
    var notice = el('p', 'wo-vehicle-notice', t('notice'));
    var workline = el('div', 'wo-vehicle-workline');
    ui.status = el('p', 'wo-vehicle-status', t('ready'));
    ui.status.setAttribute('role', 'status'); ui.status.setAttribute('aria-live', 'polite'); ui.status.setAttribute('aria-atomic', 'true');
    ui.progress = el('progress', 'wo-vehicle-progress'); ui.progress.hidden = true; ui.progress.setAttribute('aria-label', t('checking_catalog'));
    ui.cancel = makeButton(t('cancel')); ui.cancel.hidden = true;
    workline.append(ui.status, ui.progress, ui.cancel);
    ui.error = el('div', 'wo-vehicle-error'); ui.error.hidden = true; ui.error.setAttribute('role', 'alert');
    ui.errorText = el('p'); ui.retry = makeButton(t('retry')); ui.error.append(ui.errorText, ui.retry);
    ui.axleGroup = el('fieldset', 'wo-vehicle-axle'); ui.axleGroup.hidden = true;
    ui.axleGroup.append(el('legend', '', t('axle')));
    var axleButtons = el('div', 'wo-vehicle-axle-buttons'); ui.axleButtons = {};
    ['front', 'rear'].forEach(function (axle) {
      var button = makeButton(t(axle + '_wheels')); button.dataset.woAxle = axle;
      button.setAttribute('aria-pressed', String(axle === 'front'));
      button.addEventListener('click', function () {
        if (!s.staggered || s.busy || s.axle === axle) return;
        s.axle = axle; s.page = 1; Object.values(s.filters).forEach(function (set) { set.clear(); });
        var axleUrl = new URL(location.href); axleUrl.searchParams.set('axle', axle);
        history.replaceState(history.state, '', axleUrl.pathname + axleUrl.search + axleUrl.hash);
        projectAxle(); buildFilters(); render();
      });
      ui.axleButtons[axle] = button; axleButtons.append(button);
    });
    ui.axleGroup.append(axleButtons, el('p', 'wo-vehicle-axle-note', t('staggered_note')));
    ui.layout = el('div', 'wo-catalog-layout'); ui.layout.hidden = true;
    ui.mobileDiameter = el('fieldset', 'wo-vehicle-mobile-diameter');
    ui.mobileDiameter.append(el('legend', '', t('diameter')));
    ui.mobileDiameterValues = el('div', 'wo-vehicle-diameter-options');
    ui.mobileDiameterAll = makeButton(t('all_diameters'));
    ui.mobileDiameterAll.classList.add('wo-vehicle-diameter-box', 'wo-vehicle-diameter-all');
    ui.mobileDiameterAll.setAttribute('aria-pressed', 'true');
    ui.mobileDiameterButtons = new Map();
    ui.mobileDiameter.append(ui.mobileDiameterValues);
    ui.filterPanel = el('details', 'wo-filters wo-vehicle-filter-panel');
    var mobileViewport = window.matchMedia('(max-width: 799px)');
    ui.filterPanel.open = !mobileViewport.matches;
    ui.filterPanel.append(el('summary', 'wo-filters__summary', t('filters')));
    ui.filterBody = el('div', 'wo-filters__body');
    ui.clear = makeButton(t('clear_filters')); ui.clear.classList.add('wo-vehicle-clear');
    ui.filterPanel.append(ui.filterBody, ui.clear);
    var main = el('div', 'wo-vehicle-main');
    var toolbar = el('div', 'wo-results-toolbar wo-vehicle-toolbar');
    ui.count = el('p', 'wo-vehicle-count');
    var sortLabel = el('label', 'wo-vehicle-sort');
    sortLabel.append(el('span', '', t('sort')));
    ui.sort = el('select'); ui.sort.setAttribute('aria-label', t('sort'));
    [['featured', 'featured'], ['price-low', 'price_low'], ['price-high', 'price_high'], ['diameter', 'diameter_sort']].forEach(function (item) { var option = el('option', '', t(item[1])); option.value = item[0]; ui.sort.append(option); });
    sortLabel.append(ui.sort); ui.refresh = makeButton(t('refresh')); ui.refresh.classList.add('wo-vehicle-refresh');
    toolbar.append(ui.count, sortLabel, ui.refresh);
    ui.priceNote = el('p', 'wo-vehicle-price-note'); ui.priceNote.hidden = true;
    ui.empty = el('div', 'wo-no-results wo-vehicle-empty'); ui.empty.hidden = true;
    ui.grid = el('div', 'wo-results-grid');
    ui.pager = el('nav', 'wo-pagination wo-vehicle-pagination'); ui.pager.setAttribute('aria-label', t('pagination'));
    ui.previous = makeButton(t('previous')); ui.next = makeButton(t('next')); ui.page = el('span');
    ui.pager.append(ui.previous, ui.page, ui.next);
    main.append(toolbar, ui.priceNote, ui.empty, ui.grid, ui.pager); ui.layout.append(ui.mobileDiameter, ui.filterPanel, main);
    root.replaceChildren(header, notice, workline, ui.error, ui.axleGroup, ui.layout);
    function makeButton(text) { var node = el('button', 'wo-vehicle-button', text); node.type = 'button'; return node; }
    function status(text) { if (ui.status.textContent !== text) ui.status.textContent = text; }
    function checked(value) { var date = new Date(value); return Number.isFinite(date.getTime()) ? date.toLocaleString(locale, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : t('just_checked'); }
    function clearResults(message) {
      discardResults();
      preferredAxle = null;
      var clearedUrl = new URL(location.href);
      if (clearedUrl.searchParams.has('axle')) {
        clearedUrl.searchParams.delete('axle');
        history.replaceState(history.state, '', clearedUrl.pathname + clearedUrl.search + clearedUrl.hash);
      }
      root.dataset.woResultsState = 'idle';
      s.sequence++; s.controller?.abort(); s.controller = null; s.busy = false; s.last = null; s.vehicleRef = null; s.refKey = null; s.referenceAt = null; s.lastResume = null;
      s.matches = []; s.allMatches = []; s.staggered = false; s.axle = 'front'; s.groups = []; s.page = 1; s.checkedAt = null; ui.axleGroup.hidden = true; delete root.dataset.woAxle;
      s.lastForce = false; s.sort = 'featured'; s.priceRejected = 0;
      Object.values(s.filters).forEach(function (set) { set.clear(); }); ui.sort.value = 'featured';
      ui.filterBody.replaceChildren(); ui.mobileDiameterButtons.clear(); ui.mobileDiameterValues.replaceChildren(ui.mobileDiameterAll);
      ui.mobileDiameterAll.setAttribute('aria-pressed', 'true'); ui.count.textContent = ''; ui.page.textContent = '';
      ui.grid.replaceChildren(); ui.layout.hidden = true; ui.error.hidden = true; ui.progress.hidden = true; ui.cancel.hidden = true;
      ui.title.textContent = t('title'); ui.title.hidden = true; ui.vehicle.textContent = ''; status(message || t('ready'));
      root.setAttribute('aria-busy', 'false');
    }
    async function fitment(detail, signal) {
      var controller = new AbortController(), timedOut = false;
      function abort() { controller.abort(); }
      if (signal.aborted) throw new DOMException('Cancelled', 'AbortError');
      signal.addEventListener('abort', abort, { once: true });
      var timer = setTimeout(function () { timedOut = true; controller.abort(); }, 30000);
      try {
        var response = await fetch(endpoint.href, { method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign({ step: 'fitment' }, detail.vehicle)), signal: controller.signal });
        if (response.status === 401 || response.status === 403) throw new Error(t('unavailable'));
        if (response.status === 429) { var seconds = Number(response.headers.get('Retry-After')); throw new Error(Number.isFinite(seconds) && seconds > 0 && seconds <= 3600 ? t('retry_seconds', { seconds: Math.ceil(seconds) }) : t('rate_limited')); }
        var data; try { data = await response.json(); } catch (_) { throw new Error(t('error')); }
        if (!response.ok || !data || data.error) throw new Error((typeof data?.error === 'string' ? data.error : data?.error?.message) || t('error'));
        if (!Array.isArray(data.records) || data.records.length !== 1) throw new Error(t('exact_vehicle'));
        var vehicle = data.records[0];
        if (!vehicle || (!Array.isArray(vehicle.wheels) || !vehicle.wheels.length) && (!Array.isArray(vehicle.axleReferences) || !vehicle.axleReferences.length)) throw new Error(t('unsupported_vehicle'));
        return vehicle;
      } catch (error) {
        if (timedOut) throw new Error(t('timeout'));
        if (error instanceof TypeError) throw new Error(t('connection'));
        throw error;
      } finally { clearTimeout(timer); signal.removeEventListener('abort', abort); }
    }
    async function catalog(signal, sequence, force) {
      if (!force && s.memo && Date.now() - s.memo.freshnessAt < CACHE_TTL) return s.memo.data;
      if (typeof loadFastCatalog !== 'function') throw new Error(t('catalog_error'));
      var startedAt = Date.now();
      var data = await loadFastCatalog({ signal: signal, baseUrl: catalogUrl, force: Boolean(force), currency: currency, onProgress: function () { if (sequence === s.sequence && !signal.aborted) status(t('checking_catalog')); } });
      if (signal.aborted) throw new DOMException('Cancelled', 'AbortError');
      if (!data || !Array.isArray(data.variants)) throw new Error(t('catalog_error'));
      var time = Date.parse(data.checkedAt);
      s.memo = { data: data, freshnessAt: Math.min(startedAt, Number.isFinite(time) ? time : startedAt) };
      return data;
    }
    function validMoney(variant) {
      return String(variant.currency || '').toUpperCase() === currency && (typeof variant.price === 'string' || typeof variant.price === 'number') && String(variant.price).trim() !== '' && Number.isFinite(Number(variant.price)) && Number(variant.price) >= 0;
    }
    function resultScope() {
      var shopify = window.Shopify, theme = String(shopify?.theme?.id || '');
      if (!/^[1-9]\d*$/.test(theme) || shopify?.currency?.active && shopify.currency.active !== currency) return null;
      return JSON.stringify(['wo-results-v1', location.origin, entryUrl.pathname, endpoint.href, theme,
        String(shopify?.theme?.role || ''), currency, String(shopify?.locale || locale),
        String(shopify?.country || ''), String(shopify?.routes?.root || '/')].concat(catalogUrl ? ['collection-membership-v1', catalogUrl, catalogVendor || ''] : []));
    }
    function rememberCompleted() {
      if (root.dataset.woResultsState !== 'success' || !s.last || !usableReference(s.vehicleRef, s.referenceAt)) return;
      var scope = resultScope(); if (!scope) return;
      try {
        var saved = JSON.stringify({ schema: 'wo-results-v1', scope: scope, detail: s.last,
          reference: s.vehicleRef, referenceAt: s.referenceAt,
          view: { axle: s.axle, page: s.page, sort: s.sort, filters: {
            diameter: Array.from(s.filters.diameter), finish: Array.from(s.filters.finish), brand: Array.from(s.filters.brand)
          } } });
        if (saved.length > 262144) { discardResults(); return; }
        var sharedScope = referenceScope(root);
        if (sharedScope) sessionStorage.setItem(VEHICLE_REFERENCE_KEY, JSON.stringify({
          schema: 'wo-vehicle-reference-v1', scope: sharedScope, detail: s.last,
          reference: s.vehicleRef, referenceAt: s.referenceAt
        }));
        sessionStorage.setItem(RESULTS_KEY, saved);
      } catch (_) { discardResults(); }
    }
    function restoreView(view) {
      if (!view || typeof view !== 'object') return;
      if (['featured', 'price-low', 'price-high', 'diameter'].includes(view.sort)) s.sort = view.sort;
      ui.sort.value = s.sort;
      ['diameter', 'finish', 'brand'].forEach(function (key) {
        if (mobileViewport.matches && key !== 'diameter') return;
        var values = view.filters?.[key];
        if (!Array.isArray(values) || values.length > 100) return;
        var allowed = new Set(Array.from(ui.filterBody.querySelectorAll('input[data-wo-filter="' + key + '"]')).map(function (input) { return input.value; }));
        values.forEach(function (value) { if (typeof value === 'string' && allowed.has(value)) s.filters[key].add(value); });
      });
      if (Number.isSafeInteger(view.page) && view.page > 0 && view.page <= 1000) s.page = view.page;
    }
    function restoreCompleted() {
      var record, raw, scope = resultScope(), current = window.WOVehicleUrl?.read();
      try { raw = sessionStorage.getItem(RESULTS_KEY); if (raw && raw.length <= 262144) record = JSON.parse(raw); }
      catch (_) { record = null; }
      var detail = validDetail(record?.detail);
      if (scope && record?.schema === 'wo-results-v1' && record.scope === scope &&
          detail && vehiclesMatch(current, detail.vehicle) && usableReference(record.reference, record.referenceAt)) {
        search(detail, false, record); return;
      }
      discardResults();
      if (new URL(location.href).searchParams.has('wo_browse')) return;
      var shared = referenceForCurrentVehicle(root);
      if (!shared || !window.WOVehicleUrl.write(shared.detail)) return;
      // Only the vehicle reference travels. This brand gets its own catalog and fresh filters.
      search(shared.detail, false, shared);
    }

    async function search(raw, force, resumed) {
      var detail = validDetail(raw);
      if (!detail) { root.dataset.woResultsState = 'error'; ui.errorText.textContent = t('invalid_vehicle'); ui.error.hidden = false; return; }
      if (resumed && !usableReference(resumed.reference, resumed.referenceAt)) { discardResults(); status(t('expired')); return; }
      discardResults();
      if (!resumed && !force) discardVehicleReference();
      var samePrevious = s.last && KEYS.every(function (key) { return s.last.vehicle[key] === detail.vehicle[key]; });
      var requestedAxle = resumed?.view?.axle === 'rear' ? 'rear' : force && samePrevious ? s.axle : 'front';
      if (preferredAxle && KEYS.every(function (key) { return preferredAxle.vehicle[key] === detail.vehicle[key]; })) requestedAxle = preferredAxle.axle;
      root.dataset.woResultsState = 'loading';
      s.sequence++; var sequence = s.sequence; s.controller?.abort();
      var controller = new AbortController(); s.controller = controller; s.busy = true; s.last = detail; s.lastForce = Boolean(force); s.lastResume = resumed || null;
      s.matches = []; s.allMatches = []; s.staggered = false; s.axle = requestedAxle; ui.axleGroup.hidden = true; delete root.dataset.woAxle; s.groups = []; s.page = 1; s.filters = { brand: new Set(), diameter: new Set(), finish: new Set() }; s.sort = 'featured'; ui.sort.value = 'featured';
      ui.grid.replaceChildren(); ui.layout.hidden = true; ui.error.hidden = true; ui.progress.hidden = false; ui.cancel.hidden = false;
      ui.title.textContent = t('vehicle_heading', { vehicle: detail.label }); ui.title.hidden = false; ui.vehicle.textContent = ''; status(t(resumed ? 'checking_catalog' : 'checking')); root.setAttribute('aria-busy', 'true');
      try {
        var refKey = JSON.stringify(detail.vehicle);
        if (resumed) { s.vehicleRef = resumed.reference; s.refKey = refKey; s.referenceAt = resumed.referenceAt; }
        var reference = resumed ? Promise.resolve(s.vehicleRef) : force && s.vehicleRef && s.refKey === refKey && usableReference(s.vehicleRef, s.referenceAt) ? Promise.resolve(s.vehicleRef) : fitment(detail, controller.signal).then(function (vehicle) {
          if (sequence === s.sequence && !controller.signal.aborted) { s.vehicleRef = vehicle; s.refKey = refKey; s.referenceAt = Date.now(); }
          return vehicle;
        });
        var data = await Promise.all([reference, catalog(controller.signal, sequence, force)]);
        if (sequence !== s.sequence || controller.signal.aborted) return;
        if (typeof matchPlusSizeWheelCandidates !== 'function') throw new Error(t('comparison_error'));
        // A known mixed brand collection can require its intended vendor as well as membership.
        var candidates = catalogVendor ? data[1].variants.filter(function (variant) {
          return String(variant.product?.vendor || '').toLowerCase().replace(/[^a-z0-9]/g, '') === catalogVendor;
        }) : data[1].variants;
        var matches = matchPlusSizeWheelCandidates(data[0], candidates, { maxDiameterIncrease: 3 });
        if (!Array.isArray(matches)) throw new Error(t('comparison_error'));
        var unique = new Map(); s.priceRejected = 0;
        matches.forEach(function (match) {
          var variant = match.variant;
          if (!variant || !(variant.available === true || variant.backorder === true)) return;
          if (!validMoney(variant)) { s.priceRejected++; return; }
          if (!productUrl(variant)) return;
          unique.set(String(variant.id), match);
        });
        s.allMatches = Array.from(unique.values()); s.checkedAt = data[1].checkedAt || new Date().toISOString();
        s.staggered = Array.isArray(data[0].axleReferences) && data[0].axleReferences.some(function (pair) { return pair.setup === 'staggered'; });
        if (!s.staggered) s.axle = 'front';
        preferredAxle = null;
        projectAxle(); buildFilters(); if (resumed) restoreView(resumed.view); render();
        ui.title.textContent = t('vehicle_heading', { vehicle: detail.label }); ui.vehicle.textContent = '';
        status(t('complete', { date: checked(s.checkedAt) }));
        root.dataset.woResultsState = 'success';
        rememberCompleted();
      } catch (error) {
        if (sequence !== s.sequence) return;
        root.dataset.woResultsState = 'error';
        controller.abort();
        ui.errorText.textContent = error.name === 'AbortError' ? t('cancelled') : error.message || t('error');
        ui.error.hidden = false; status(error.name === 'AbortError' ? t('cancelled') : t('error'));
      } finally {
        if (sequence === s.sequence) { s.busy = false; s.controller = null; ui.progress.hidden = true; ui.cancel.hidden = true; root.setAttribute('aria-busy', 'false'); }
      }
    }
    function projectAxle() {
      s.matches = s.staggered ? s.allMatches.flatMap(function (match) {
        var axleMatch = match.axleMatches && match.axleMatches[s.axle];
        return axleMatch ? [Object.assign({}, match, axleMatch, { axle: s.axle })] : [];
      }) : s.allMatches;
      ui.axleGroup.hidden = !s.staggered;
      if (s.staggered) root.dataset.woAxle = s.axle; else delete root.dataset.woAxle;
      ['front', 'rear'].forEach(function (axle) { ui.axleButtons[axle].setAttribute('aria-pressed', String(s.axle === axle)); });
    }
    function brand(match) { return String(match.variant.product?.vendor || t('other_brand')); }
    function finish(match) { return String(match.variant.finish || '').trim(); }
    function cardTitle(match) {
      var product = match.variant.product || {}, base = product.cardTitleBase;
      if (typeof base === 'string' && base.trim()) return base.trim() + (finish(match) ? ' ' + finish(match) : '');
      // Older catalog responses retain their finish text while removing the brand prefix.
      var title = String(product.title || t('wheel')).trim(), prefix = title.toLowerCase().indexOf(' wheels ');
      if (prefix >= 0 && title.slice(prefix + 8).trim()) return title.slice(prefix + 8).trim();
      var vendor = String(product.vendor || '').trim();
      return vendor && title.toLowerCase().indexOf(vendor.toLowerCase() + ' ') === 0 ? title.slice(vendor.length).trim() : title;
    }
    function productId(match) { return String(match.variant.product?.id || match.variant.product?.handle || ''); }
    function variantSort(a, b) { return Number(a.specification.diameter) - Number(b.specification.diameter) || Number(a.specification.width) - Number(b.specification.width) || Number(a.specification.offset) - Number(b.specification.offset) || String(a.variant.id).localeCompare(String(b.variant.id)); }
    var featuredProductOrder = new Map(["16057700254065","16057700974961","4698139164755","16057701073265","16057700811121","16057705890161","6801267589203","15379082445169","4698054590547","16057705759089","4698169213011","4698162987091","4698163019859","16057699860849","4698088243283","4498444419155","4698054557779","16057705038193","6801267753043","15379082412401","16057705267569","16057699598705","16057704907121","6535986937939","16057699205489","16057704808817","16057701859697","16057705496945","6535986905171","16057699991921","4698138738771","16057700548977","16057706217841","16057697239409","16057699795313","4697987317843","16057704710513","16057704579441","16054654730609","16054654337393","16057704350065","16057705365873","4698182025299","16057704481137","16057702941041","16057703956849","16057704055153","4698181959763","4698163445843","16057704251761","16057701466481","4698138804307","16057699664241","16057702515057","16057702646129","4698163806291","6801269260371","6801269293139","16057700647281","16057703727473","16057702416753","4698079330387","16057702121841","16057702809969","16057702023537","16057700155761","6801253466195","6801269915731","4698013204563","16057703530865","16057701335409","4698089947219","16057705234801","4698073890899","16057703563633","16057702252913","16057706054001","16057696977265","16057703760241","16057703465329","16057703498097","6801254252627","16057706021233","16057704087921","16054654796145","16057699369329","16057699303793","16054654501233","16057702973809","16057696846193","16057698091377","16057703793009","16057697796465","16057701204337","16057696911729","16054654304625","16057699467633","16057703825777","16057701630321","16057700843889","16057700876657","16057701728625","16057703301489","16057703137649","4498444288083","4697986990163","4697987088467","4697987383379","4698073858131","4698079264851","4698169245779","15379084247409","16054652076401","16054653649265","16054653747569","16054653813105","16054653878641","16054653976945","16054654042481","16054654140785","16054654206321","16054654435697","16054654468465","16054654599537","16057698615665","16057698582897","16057698713969","16057698779505","16057699139953","16055877108081","16055877370225","16055877632369","16055877861745","16055878320497","16055878680945","16055878844785","16055878975857","16055879106929","16055879238001","16055879369073","16055879467377","16055879663985","16055879795057","16055880024433","16055880286577","16055880515953","16055880712561","16055880909169","16055881105777","16055881335153","16055881433457","16055881597297","16055881662833","16055881793905","16055881924977","16055882023281","16055882318193","16055882514801","16055882744177","16055883071857","16055883301233","16055883530609","16055883727217","16055883891057","16055884087665","16055884251505","16055884382577","16055884513649","16055884677489","16055884775793","16055884939633","16055885103473","16055885267313","16055885496689","16055885758833","16055886020977","16055886184817","16055886512497","16055886676337","16055886938481","16055887069553","16055887200625","16055887364465","16055887561073","16055887790449","16055887954289","16055888118129","16055888281969","16055888413041","16055888544113","16055888576881","16055888806257","16055888871793","16055889068401","16055889265009","16055889494385","16055889527153","16055889690993","16055889723761","16055889920369","16055889985905","16055890084209","16055890149745","16055890215281","16055890248049","16055890379121","16055890444657","16055890510193","16055890575729","16055891165553","16055891329393","16057689932145","16057690554737","16057690849649","16057690456433","16057690653041","16057691046257","16057690816881","16057690620273","16057690751345","16057691177329","16057690947953","16057691079025","16057691308401","16057691373937","16057691439473","16057691144561","16057691537777","16057691275633","16057691799921","16057691734385","16057692062065","16057691898225","16057692225905","16057691636081","16057691668849","16057691701617","16057692488049","16057692193137","16057692029297","16057692422513","16057691832689","16057692586353","16057692324209","16057692094833","16057692717425","16057692356977","16057692750193","16057692619121","16057692684657","16057692848497","16057692979569","16057692553585","16057692881265","16057693471089","16057693241713","16057693340017","16057693536625","16057693110641","16057693208945","16057693077873","16057693143409","16057693667697","16057693405553","16057693372785","16057693766001","16057693733233","16057693700465","16057693864305","16057694224753","16057694126449","16057694421361","16057694028145","16057693962609","16057694519665","16057694159217","16057694257521","16057694814577","16057694781809","16057694585201","16057694552433","16057694978417","16057694880113","16057695109489","16057694749041","16057695142257","16057695175025","16057694912881","16057695273329","16057694945649","16057695633777","16057695011185","16057695502705","16057695371633","16057695699313","16057695666545","16057695306097","16057695338865","16057695469937","16057696125297","16057695764849","16057696321905","16057696354673","16057696158065","16057696452977","16057695797617","16057695830385","16057695994225","16057696289137","16057695961457","16057696190833","16057696616817","16057696584049","16057696420209","16057696682353","16057696551281","16057696813425","16057696715121","16056173101425","16056173134193","16056173199729","16056173265265","16056173298033","16056173330801","16056173363569","16056173396337","16056173429105","16056173461873","16056173494641","16056173527409","16056173560177","16056173592945","16056173625713","16056173691249","16056173724017","16056173756785","16056173789553","16056173822321","16056173855089","16056173887857","16056173953393","16056173986161","16056174018929","16056174051697","16056174084465","16056174117233","16056174150001","16056174182769","16056174215537","16056174248305","16056174281073","16056174313841","16056174346609","16056174379377","16056174412145","16056174444913","16056174510449","16056174543217","16056174575985","16056174641521","16056174674289","16056174707057","16056174772593","16056174805361","16056174838129","16056174870897","16056174903665","16056174936433","16056174969201","16056175001969","16056175034737","16056175067505","16056175100273","16056175133041","16056175165809","16056175198577","16056175231345","16056175264113","16056175296881","15871008702833","15871007981937","15871007916401","15871008014705","15871007883633","15871008211313","15871008047473","15402150363505","15402150297969","15871007785329","15418669269361","15871221727601","15871007752561","15871007555953","15871007588721","15386017169777","6571324997715","6571324932179","6571324670035","6571324702803","6571324506195","6571324604499","6571324276819","6571324571731","6857079586899","6857078341715","6571348295763","6571348328531","6571348230227","6571348262995","6571347312723","6571348394067","6571348459603","6571347378259","6571347542099","6571347935315","6571347771475","6571347902547","6571348000851","6571348164691","6857078931539","6857079226451","6857079357523","15386015859057","15386015990129","15386016088433","15386016022897","15386015629681","15386015760753","15386016448881","15386016153969","15386098631025","15386016121201","15386016055665","15386437091697","15386526122353","15386811695473","15386364936561","15386667254129","15386098336113","6842429472851","4698139394131","6565044486227","6565043994707","6783126732883","4698086375507","4698171932755","4698172358739","4698172588115","4698171474003","4698171572307","4698171539539","4485897617491","4485897683027","4485897912403","6783125422163","4698139492435","4698139590739","6571317854291","6571317821523","6571318116435","6571316445267","6571316478035","6571316510803","6571316183123","6571346395219","6571346329683","6571346362451","6571346133075","6857076047955","6857076015187","6571345772627","6571345805395","6571319066707","4721465163859","4721465262163","4721464639571","4721464737875","4721464148051","4721464213587","4721464082515","4721464016979","4721463885907","4721463787603","4739292495955","4739291807827","6571317559379","6571317657683","6571317100627","6571317330003","6571317198931","6571317166163","4698134249555","4698133692499","4481220739155","4481219854419","4698131038291","4698052657235","4698052493395","4698052591699","4698052755539","4698052853843","4698052722771","4481218707539","4698052132947","4481218347091","4481217921107","4481217626195","4481217790035","4698066092115","4698066124883","4698066255955","4481216020563","4698065993811","4481216282707","6801265164371","6801265131603","6801264771155","6801264705619","6801262608467","6801260413011","6801260445779","6801245798483","6801246257235","6801254219859","6801254121555","6801253957715","6801254187091","6801253662803","6801253630035","6801253433427","6801253695571","6801253859411","6801253728339","6801253924947","6801248157779","6801253892179","6801254154323","4717867204691","4717867302995","4717867434067","4717866909779","4717866287187","6571327455315","6857075032147","6857074540627","6857074671699","6535987822675","6535987789907","6535987691603","6535995719763","6535988183123","6535988150355","4481218838611","4698052198483","4698052984915","4698085949523","4698086015059","4698086047827","4698132971603","4698171244627","4698171277395","4698171375699","4698171637843","4698171768915","4698171834451","4698177699923","4698177732691","4698285998163","4698286522451","4698286555219","4698286719059","4698286784595","4698286817363","4698286850131","4698286882899","4698286915667","4698287013971","4698287046739","4698287079507","4698287112275","4698287145043","4698287177811","4698287210579","4717864583251","4717864616019","4717864648787","4717864681555","4717864714323","4717864747091","4717864779859","4717864812627","4717864910931","4717864943699","4717864976467","4717865009235","4717865042003","4717865074771","4717865140307","4717865173075","4717865205843","4717865238611","4717865271379","4717865304147","4717865336915","4717865369683","4717865402451","4717865435219","4717865467987","4717865500755","4717865533523","4717865566291","4717865599059","4717865631827","4717865730131","4717865828435","4717865861203","4717865926739","4717865959507","4717865992275","4717866090579","4717866123347","4717866156115","4717866188883","4717866221651","4717866254419","4717866319955","4717866352723","4717866451027","4717866516563","4717866680403","4717866713171","4717866745939","4717866778707","4717866811475","4717866942547","4717866975315","4717867008083","4717867040851","4717867073619","4717867106387","4717867139155","4717867171923","4717867237459","4717867466835","4717867499603","4717867532371","4717867565139","4717867597907","4717867663443","4717867696211","4717867728979","4717867761747","4717867794515","4717867827283","4717867860051","4717867892819","4717867925587","4717867958355","4717867991123","4717868023891","4717868056659","4717868089427","4717868122195","4717868154963","4717868187731","4717868253267","4717868417107","4717868449875","4717868482643","4717868515411","4717868548179","4717868580947","4717868613715","4717868646483","4717868679251","4717868777555","4717868810323","4717868875859","4717868908627","4717868941395","4717869006931","4717869105235","4717869138003","4717869170771","4717869203539","4717869236307","4717869269075","4717869334611","4717869367379","4717869400147","4717869432915","4717869629523","4717869695059","4717869727827","4717869760595","4717869858899","4717869891667","4717869924435","4717869957203","4717869989971","4717870022739","4717870350419","4717870383187","4717870415955","4717870448723","4717870481491","4717870514259","4717870547027","4717870579795","4717870612563","4717870678099","4717870710867","4717870743635","4717870776403","4717870809171","4717870841939","4717870874707","4717870973011","4717871005779","4717871038547","4717871071315","4717871104083","4717871136851","4717871169619","4717871235155","4717871267923","4717871300691","4717871333459","4717871366227","4717871431763","4717871464531","4717871497299","4717871530067","4717871562835","4717871661139","4717871693907","4717871726675","4717871759443","4717871792211","4717871824979","4717871857747","4717871890515","4717871988819","4717872021587","4717872414803","4717872447571","4717872480339","4717872513107","4717872545875","4717873004627","4717873037395","4717873070163","4717873102931","4717873135699","4717873201235","4721464508499","4721464541267","4721465032787","4721465065555","4721465393235","4721465426003","4721465589843","4721465622611","4721465655379","4721465753683","4721465917523","4721465950291","4721465983059","4721466081363","4721466146899","4721466212435","4721466376275","4721466802259","4721466867795","4721466900563","4721466998867","4721467097171","4721467162707","4721467261011","4721467293779","4721467392083","4721467424851","4721467555923","4721467588691","4721467621459","4721467686995","4721467719763","4721467752531","4721467785299","4721467818067","4739291447379","4739291480147","4739291545683","4739291578451","4739291676755","4739291709523","4739291742291","4739291775059","4739291840595","4739291873363","4739291938899","4739291971667","4739292004435","4739292069971","4739292102739","4739292135507","4739292168275","4739292201043","4739292299347","4739292332115","4739292364883","4739292397651","4739292430419","4739292463187","4739292528723","4739292561491","4739292594259","4739292627027","4739292659795","4739292692563","4739292725331","4739292790867","4739292823635","4739292856403","4739292921939","4739292954707","4739293020243","4739293053011","4739293118547","4739293151315","4739293249619","4739293315155","4739293347923","4739293446227","4739293478995","4739293544531","4739293577299","4739293642835","4739293675603","4739293708371","4739293773907","4739293806675","4739293872211","4739293970515","4739294003283","4739294167123","4739294265427","4739294298195","4739294363731","4739294396499","4739294429267","4739294462035","4739294527571","4739294593107","4739294658643","4739294691411","4739294756947","4739294822483","4739294855251","4739294953555","4739295019091","6535972683859","6564481237075","6564481269843","6564481302611","6564481368147","6564481400915","6564481531987","6564481564755","6564481728595","6564481892435","6564481925203","6564481957971","6564481990739","6564482023507","6564482056275","6564482089043","6564482121811","6564482154579","6564482187347","6564482220115","6564482252883","6564482285651","6564482318419","6564482383955","6564482416723","6564482482259","6564482646099","6564482678867","6564482777171","6564482809939","6564482842707","6564482908243","6564483006547","6564483039315","6564483072083","6564483104851","6564483137619","6564483170387","6564483399763","6564483432531","6564483465299","6564483498067","6564483530835","6564485726291","6564485759059","6565044256851","6565044289619","6565044387923","6565044518995","6565044584531","6565044617299","6571316314195","6571316674643","6571316936787","6571317067859","6571317264467","6571317493843","6571317526611","6571317592147","6571317690451","6571317985363","6571318149203","6571324309587","6571327225939","6571327389779","6571327553619","6571327782995","6571346526291","6571347574867","6571348066387","6571348099155","6650697515091","6650697678931","6650697744467","6650697810003","6650697842771","6650697875539","6650697941075","6650697973843","6650698006611","6650698039379","6650698072147","6650698104915","6650698137683","6650698170451","6650698203219","6650698268755","6650698301523","6650698334291","6650698367059","6650698399827","6650698432595","6650698465363","6650698498131","6650698530899","6650698563667","6650699153491","6650699186259","6650699219027","6650699251795","6650699284563","6650699317331","6650699350099","6650699382867","6650699415635","6650699448403","6650699481171","6650700070995","6705948852307","6705949212755","6783125454931","6783126372435","6783126569043","6783126929491","6783127027795","6783127126099","6783127158867","6783127224403","6783127289939","6783127322707","6783127355475","6783127453779","6783127519315","6783127584851","6783127650387","6801249992787","6801250123859","6801250320467","6801250517075","6801250648147","6801250746451","6801250877523","6801250910291","6801250943059","6801251041363","6801251139667","6801251237971","6801251369043","6801251467347","6801251500115","6801251565651","6801251598419","6801251631187","6801251762259","6801253498963","6808025661523","6808025694291","6808025858131","6808026120275","6857074737235","6857074999379","6857078800467","6857078898771","6857079160915","6857079324755","15378903794033","15378904220017","15378904252785","15378904285553","15378904318321","15378904351089","15378905006449","15378905039217","15378905071985","15378905465201","15378905497969","15378905530737","15378905629041","15378905661809","15378905727345","15378905760113","15378905792881","15378905825649","15378905858417","15378905923953","15378906218865","15378906284401","15378906317169","15378906349937","15378906382705","15378906415473","15378906579313","15378906612081","15378906677617","15378906710385","15378906775921","15378906808689","15378906841457","15378906906993","15378906939761","15378906972529","15378907038065","15378907070833","15378907103601","15378907169137","15378907234673","15378907398513","15378907464049","15378907890033","15378907988337","15378908184945","15378908217713","15378908316017","15378908348785","15378908381553","15378908447089","15378908512625","15378908545393","15378908578161","15378908610929","15378908643697","15378908676465","15378908709233","15378908774769","15378908873073","15378908905841","15378908938609","15378908971377","15378909036913","15378909069681","15378909102449","15378909135217","15378909167985","15378909200753","15378909233521","15378909266289","15378909299057","15378909331825","15378909364593","15378909397361","15378909430129","15378909462897","15378909495665","15378909528433","15378909561201","15378909593969","15378909626737","15378909659505","15378909692273","15378909725041","15378909757809","15378909790577","15378909823345","15378909856113","15378909888881","15378909921649","15378909954417","15378909987185","15378910019953","15378910052721","15378910085489","15378910118257","15378910151025","15378910183793","15378910216561","15378910249329","15378910282097","15378910314865","15378910347633","15378910380401","15378910413169","15378910445937","15378910478705","15378910511473","15378910544241","15378910577009","15378910609777","15378910642545","15378910675313","15378994102641","15378994135409","15378994168177","15378994200945","15378994233713","15378994266481","15378994299249","15378994332017","15378994364785","15378994397553","15378994430321","15378994463089","15378994495857","15378994528625","15378994561393","15378994594161","15378994626929","15378995937649","15378996298097","15378996330865","15378996363633","15378996396401","15378996658545","15378996691313","15378996986225","15378998034801","15378998591857","15378998821233","15378998854001","15378998886769","15378998919537","15378998952305","15378998985073","15378999017841","15378999050609","15378999083377","15378999116145","15378999148913","15378999181681","15378999378289","15379079823729","15379079922033","15379079954801","15379079987569","15379080085873","15379080118641","15379080184177","15379080216945","15379080282481","15379080315249","15386017268081","15386017300849","15386437058929","15386497548657","15386667319665","15386915209585","15387002110321","15387361837425","15387632599409","15387828355441","15388150301041","15388455993713","15388530344305","16054657778033","16055871373681","16055872684401","16055872848241","16055872979313","16055873012081","16055873110385","16055873339761","16055873372529","16055873634673","16055873667441","16055873831281","16055874126193","16055874158961","16055874388337","16055874584945","16055874814321","16055874847089","16055874879857","16055875142001","16055875338609","16055875567985","16055875830129","16055875862897","16055876026737","16055876059505","16055876256113","16055876288881","16055876518257","16055876551025","16055876583793","16055876714865","16055876747633","16055877009777","16055878091121","16055878353265","16055878484337","16055890313585","16055890739569","16055890870641","16055890968945","16055891001713","16055891460465","16055891591537","16055891624305","16055891788145","16055891820913","16055891886449","16055891919217","16055891984753","16055892050289","16055892181361","16055892246897","16055892279665","16055892377969","16055892476273","16055892541809","16055892705649","16055892869489","16056175362417","16056175395185","16056175427953","16056175460721","16056175493489","16056175526257","16056175559025","16056175591793","16056175624561","16056175657329","16056175722865","16056175755633","16056175821169","16056175853937","16056175886705","16056175919473","16056175952241","16056175985009","16056176017777","16056176050545","16056176116081","16056176148849","16056176181617","16056176247153","16056176279921","16056176312689","16056176378225","16056176410993","16056176443761","16056176476529","16056176509297","16056176542065","16056176574833","16056176607601","16056176640369","16056176673137","16056176771441","16056480432497","16056481284465","16056481382769","16056481481073","16056481579377","16056481710449","16056481775985","16056481874289","16056481907057","16056481972593","16056482038129","16056482136433","16056482169201","16056482333041","16056482398577","16056482464113","16056482595185","16056482693489","16056482791793","16056482922865","16056482955633","16056483021169","16056483053937","16056483152241","16056483217777","16056483316081","16056483414385","16056483479921","16056483578225","16056483709297","16056483774833","16056483873137","16056483938673","16056484004209","16056484102513","16056484168049","16056484233585","16056484299121","16056484364657","16056484397425","16056484462961","16056484495729","16056484561265","16056484626801","16056484725105","16056484823409","16056484888945","16056484954481","16056485052785","16056485151089","16056485216625","16056485282161","16056485347697","16056485478769","16056485675377","16056485740913","16056485773681","16056485970289","16056486003057","16056486068593","16056486232433","16056486297969","16056486363505","16056486429041","16056486560113","16056486658417","16056486855025","16056486953329","16056487051633","16056487182705","16056487281009","16056487379313","16056487444849","16056487543153","16056487674225","16056487772529","16056487870833","16056487903601","16056488001905","16056488100209","16056488165745","16056488296817","16056488362353","16056488460657","16056488526193","16056488624497","16056488690033","16056488788337","16056488853873","16056488984945","16056489050481","16056489083249","16056489214321","16056489312625","16056489410929","16056489509233","16056489607537","16056489705841","16056489804145","16056489902449","16056489935217","16056490066289","16056490131825","16056490262897","16056490361201","16056490393969","16056490525041","16056490623345","16056490721649","16056490819953","16056490885489","16056491016561","16056491082097","16056491180401","16056491311473","16056491377009","16056491475313","16056491606385","16056491671921","16056491802993","16056491835761","16056491966833","16056492032369","16056492130673","16056492294513","16056492392817","16056492491121","16056492556657","16056492654961","16056492786033","16056492884337","16056492949873","16056493048177","16056493146481","16056493212017","16056493277553","16056493408625","16056493474161","16056493605233","16056493670769","16056493801841","16056493900145","16056494031217","16056494195057","16056494260593","16056494391665","16056494489969","16056494621041","16056494653809","16056494752113","16056494883185","16056494981489","16056495014257","16056495112561","16056495210865","16056495243633","16056495309169","16056495341937","16056495440241","16056495538545","16056495636849","16056495735153","16056495866225"].map(function (id, index) { return [id, index]; }));
    var featuredPriorityHandles = new Map([["vors-wheels-tr4-hyper-black",0],["vors-wheels-tr4-black",1],["mrr-wheels-hr3-silver",2],["vors-wheels-tr4-silver-machined",3],["vors-wheels-tr4-white",4],["vors-wheels-vr8-silver",5],["mrr-wheels-gf5-black",6],["mrr-wheels-gf5-black-fit-corvette-c8",7],["mrr-wheels-m017-gloss-black",8],["vors-wheels-vr8-hyper-black",9],["mrr-wheels-m228-fit-camaro-black",10],["mrr-wheels-flow-forge-m755-fit-corvette-black",11],["mrr-wheels-flow-forge-m755-fit-camaro-black",12],["vors-wheels-sp1-silver-machined",13],["mrr-wheels-gt1-black",14],["mrr-wheels-gt1-hyper-silver",15],["mrr-wheels-m017-gloss-gun-metal",16],["vors-wheels-tr37-white",17],["mrr-wheels-gf5-silver-machine-face",18],["mrr-wheels-gf5-silver-machine-face-fit-corvette-c8",19],["vors-wheels-tr37-black",20],["vors-wheels-tr4-bronze",21],["vors-wheels-tr37-hyper-black",22],["mrr-wheels-fs1-raw",23],["vors-wheels-vr8-gloss-black",24],["vors-wheels-tr37-silver-machined",25],["vors-wheels-ar5-silver-machined",26],["vors-wheels-vr7-silver",27],["mrr-wheels-fs6-raw",28],["vors-wheels-sp1-white",29],["mrr-wheels-hr9-silver",30],["vors-wheels-sp1-matte-black",31],["vors-wheels-vr7-black",32],["mrr-wheels-m392-matte-black",33],["vors-wheels-sp1-hyper-black",34],["mrr-wheels-vp3-silver-machined-face",35],["vors-wheels-tr37-bronze",36],["vors-wheels-vr3-silver",37],["mrr-forged-wheels-forged-f23-gloss-black-left",38],["mrr-forged-wheels-forged-f23-gloss-black-right",39],["vors-wheels-tr10-white",40],["vors-wheels-vr7-gun-metal",41],["mrr-wheels-gf6-silver",42],["vors-wheels-vr3-gold",43],["vors-wheels-ar1-silver-machined",44],["vors-wheels-tr88-bronze",45],["vors-wheels-tr10-black",46],["mrr-wheels-gf6-black",47],["mrr-wheels-m650-matte-black",48],["vors-wheels-tr88-silver-machined",49],["vors-wheels-lt61-silver-machined",50],["mrr-wheels-hr9-matte-black",51],["vors-wheels-ar5-bronze",52],["vors-wheels-tr7-black",53],["vors-wheels-tr7-bronze",54],["mrr-wheels-m350-gloss-black",55],["mrr-wheels-m024-gloss-black",56],["mrr-wheels-flow-forge-m024-fit-camaro-black",57],["vors-wheels-tr3-white",58],["vors-wheels-tr88-black",59],["vors-wheels-tr3-bronze",60],["mrr-wheels-uo2-hyper-silver",61],["vors-wheels-lt61-bronze",62],["vors-wheels-tr7-white",63],["vors-wheels-lt61-hyper-black",64],["vors-wheels-tr3-silver",65],["mrr-wheels-flow-forge-m024-fit-corvette-gun-metal",66],["mrr-wheels-flow-forge-m024-fit-camaro-gun-metal",67],["mrr-wheels-t228-gloss-black",68],["vors-wheels-lt05-black",69],["vors-wheels-lt61-black",70],["mrr-wheels-gf9-silver",71],["vors-wheels-vr2-white",72],["mrr-wheels-rw2-black-chrome-lip",73],["vors-wheels-lt37-white",74],["vors-wheels-ar5-black",75],["vors-wheels-vr2-silver",76],["mrr-wheels-gf26-gloss-black",77],["vors-wheels-lt01-white",78],["vors-wheels-lt01-black",79],["vors-wheels-lt05-white",80],["klutch-wheels-sl2-silver-machined-lip",81],["vors-wheels-vr2-black",82],["vors-wheels-lt37-black",83],["mrr-forged-wheels-forged-f10-gloss-black-right",84],["vors-wheels-sp2-bronze",85],["vors-wheels-sp2-black",86],["mrr-forged-wheels-forged-f10-gloss-black-left",87],["vors-wheels-tr7-gun-metal",88],["mrr-wheels-vp4-black-machined-lip",89],["mrr-forged-wheels-forged-f25-gloss-black-left",90],["vors-wheels-lt10-white",91],["mrr-forged-wheels-forged-f25-gloss-black-right",92],["vors-wheels-tr10-bronze",93],["mrr-wheels-vp4-silver-machined-lip",94],["mrr-wheels-gf26-bronze",95],["vors-wheels-sp2-silver-machined",96],["vors-wheels-lt10-black",97],["vors-wheels-lt84-black",98],["vors-wheels-lt01-silver",99]]);
    function rank(group) {
      var product = group.variants[0].variant.product || {};
      var id = String(product.id || group.id || '').split('/').pop();
      var position = featuredProductOrder.get(id);
      if (position === undefined) position = featuredPriorityHandles.get(String(product.handle || group.id || ''));
      if (position !== undefined && position < 100) return position;
      var name = brand(group.variants[0]).toLowerCase().replace(/[^a-z0-9]/g, '');
      var brands = ['vors', 'mrr', 'aodhan', 'mst', 'avid1'];
      var bucket = brands.indexOf(name);
      if (bucket < 0) bucket = brands.length;
      return (bucket + 1) * 10000 + (position === undefined ? 9999 : position);
    }
    function buildFilters() {
      ui.filterBody.replaceChildren();
      [['diameter', function (match) { return String(match.specification.diameter); }], ['finish', finish], ['brand', brand]].forEach(function (pair) {
        var key = pair[0], values = key === 'finish'
          ? finishFilterOptions(s.matches.map(finish))
          : Array.from(new Set(s.matches.map(pair[1]).filter(Boolean)));
        values.sort(key === 'diameter' ? function (a, b) { return Number(a) - Number(b); } : function (a, b) { return a.localeCompare(b); });
        if (key === 'diameter') {
          ui.mobileDiameterValues.replaceChildren(ui.mobileDiameterAll); ui.mobileDiameterButtons.clear();
          values.forEach(function (value) {
            var button = makeButton(value + '″'); button.classList.add('wo-vehicle-diameter-box');
            button.dataset.woDiameter = value; button.setAttribute('aria-label', t('diameter_value', { diameter: value }));
            button.setAttribute('aria-pressed', 'false');
            button.addEventListener('click', function () {
              if (s.filters.diameter.has(value)) s.filters.diameter.delete(value); else s.filters.diameter.add(value);
              s.page = 1; render();
            });
            ui.mobileDiameterButtons.set(value, button); ui.mobileDiameterValues.append(button);
          });
          ui.mobileDiameter.hidden = values.length === 0;
        }
        var group = el('details', 'wo-filter-group'); group.open = true; group.dataset.woFilterGroup = key;
        group.append(el('summary', '', t(key))); var list = el('div', 'wo-filter-values');
        values.forEach(function (value) {
          var label = el('label', 'wo-native-choice'), input = el('input'); input.type = 'checkbox'; input.value = value; input.dataset.woFilter = key;
          input.setAttribute('aria-label', key === 'diameter' ? t('diameter_value', { diameter: value }) : value);
          label.append(input, el('span', '', key === 'diameter' ? t('diameter_value', { diameter: value }) : value)); list.append(label);
          input.addEventListener('change', function () { if (input.checked) s.filters[key].add(value); else s.filters[key].delete(value); s.page = 1; render(); });
        });
        group.append(list); ui.filterBody.append(group);
      });
    }
    function groups() {
      var map = new Map();
      s.matches.forEach(function (match) {
        if (s.filters.brand.size && !s.filters.brand.has(brand(match))) return;
        if (s.filters.diameter.size && !s.filters.diameter.has(String(match.specification.diameter))) return;
        if (!finishMatchesFilter(finish(match), s.filters.finish)) return;
        var id = productId(match); if (!id) return;
        if (!map.has(id)) map.set(id, { id: id, variants: [] });
        map.get(id).variants.push(match);
      });
      var result = Array.from(map.values());
      result.forEach(function (group) { group.variants.sort(variantSort); group.title = String(group.variants[0].variant.product?.title || t('wheel')); group.price = Number(group.variants[0].variant.price); group.diameter = Number(group.variants[0].specification.diameter); });
      result.sort(function (a, b) {
        if (s.sort === 'price-low' && a.price !== b.price) return a.price - b.price;
        if (s.sort === 'price-high' && a.price !== b.price) return b.price - a.price;
        if (s.sort === 'diameter' && a.diameter !== b.diameter) return a.diameter - b.diameter;
        return (s.sort === 'featured' ? rank(a) - rank(b) : 0) || a.title.localeCompare(b.title) || a.id.localeCompare(b.id);
      });
      return result;
    }
    function productUrl(variant, axle) {
      var raw = variant.productUrl || variant.product?.onlineStoreUrl; if (!raw) return null;
      try {
        var url = new URL(raw), handle = String(variant.product?.handle || ''), id = String(variant.id).split('/').pop();
        if (url.protocol !== 'https:' || !['www.wheelsoutlet.com', 'wheelsoutlet.com'].includes(url.hostname.toLowerCase()) || url.username || url.password) return null;
        if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/i.test(handle) || url.pathname.replace(/\/$/, '') !== '/products/' + handle || !/^\d+$/.test(id)) return null;
        url.searchParams.set('variant', id);
        if (!window.WOVehicleCart) return url.href;
        if (!axle) return window.WOVehicleCart.productUrl(url.href, s.last);
        var axleOptions = { front: [], rear: [] }, seen = { front: new Set(), rear: new Set() };
        s.allMatches.forEach(function (match) {
          if (String(match.variant?.product?.handle || '') !== handle) return;
          var candidateId = String(match.variant.id).split('/').pop();
          if (!/^[1-9]\d{0,29}$/.test(candidateId)) return;
          ['front', 'rear'].forEach(function (axis) {
            if (match.axleMatches?.[axis] && !seen[axis].has(candidateId)) {
              seen[axis].add(candidateId); axleOptions[axis].push(candidateId);
            }
          });
        });
        var purchase = { axle: axle, variantId: id, axleOptions: axleOptions };
        return window.WOVehicleCart.productUrl(url.href, s.last, purchase) ||
          window.WOVehicleCart.productUrl(url.href, s.last, { axle: axle, variantId: id });
      } catch (_) { return null; }
    }
    function imageSource(image) {
      var raw = typeof image === 'string' ? image : image?.src || image?.url;
      if (!raw) return null;
      try { var url = new URL(raw, 'https://www.wheelsoutlet.com'); return url.protocol === 'https:' ? url.href : null; } catch (_) { return null; }
    }
    function imageForWidth(src, width) {
      try {
        var url = new URL(src);
        var shopify = url.hostname === 'cdn.shopify.com' && url.pathname.indexOf('/s/files/') === 0;
        var storefront = ['www.wheelsoutlet.com', 'wheelsoutlet.com'].includes(url.hostname) && url.pathname.indexOf('/cdn/shop/') === 0;
        if (url.protocol !== 'https:' || (!shopify && !storefront)) return src;
        url.searchParams.set('width', String(width)); return url.href;
      } catch (_) { return src; }
    }
    function sameFinishImage(match) {
      var name = finish(match);
      var direct = imageSource(match.variant.image); if (direct) return direct; if (!name) return null;
      var related = s.matches.find(function (other) { return productId(other) === productId(match) && finish(other) === name && imageSource(other.variant.image); });
      return related ? imageSource(related.variant.image) : null;
    }
    function money(variant) { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(Number(variant.price)); }

    var installmentCache = new Map(), installmentQueue = [], installmentActive = 0;
    function pumpInstallments() {
      while (installmentActive < 4 && installmentQueue.length) {
        var task = installmentQueue.shift();
        installmentActive++;
        task.run().then(task.resolve, task.reject).finally(function () { installmentActive--; pumpInstallments(); });
      }
    }
    function installmentMarkup(variant) {
      var href = productUrl(variant, null);
      if (!href) return Promise.reject(new Error('Invalid installment product'));
      var url = new URL(href);
      url.protocol = location.protocol; url.host = location.host;
      url.search = '';
      url.searchParams.set('view', 'wo-installments');
      url.searchParams.set('variant', String(variant.id).split('/').pop());
      var preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      var key = url.href + '|' + currency;
      if (!installmentCache.has(key)) {
        var pending = new Promise(function (resolve, reject) {
          installmentQueue.push({ resolve: resolve, reject: reject, run: async function () {
            var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 10000);
            try {
              var response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal });
              if (!response.ok) throw new Error('Installments unavailable');
              var html = await response.text();
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var form = doc.querySelector('form[data-wo-vehicle-installment-form]');
              if (!form || !form.querySelector('shopify-payment-terms')) throw new Error('Installments unavailable');
              return form;
            } finally { clearTimeout(timer); }
          } });
          pumpInstallments();
        }).catch(function (error) { installmentCache.delete(key); throw error; });
        installmentCache.set(key, pending);
      }
      return installmentCache.get(key);
    }
    var installmentObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        installmentObserver.unobserve(entry.target);
        entry.target.woLoadInstallments?.();
      });
    }, { rootMargin: '300px' }) : null;

    function card(group, index) {
      var wrapper = el('div', 'wo-result-item'), article = el('article', 'wo-product-card wo-editorial-card');
      article.dataset.productId = group.id;
      var imageLink = el('a', 'wo-editorial-image');
      var image = el('img', 'wo-card-image'); image.loading = index < 5 ? 'eager' : 'lazy'; image.decoding = 'async'; image.width = 640; image.height = 640;
      var placeholder = el('span', 'wo-vehicle-image-placeholder', t('image_unavailable'));
      imageLink.append(image, placeholder);
      var info = el('div', 'wo-editorial-info'), brandNode = el('p', 'wo-editorial-brand');
      var title = el('h2', 'wo-editorial-title'), titleLink = el('a'); title.append(titleLink);
      var price = el('p', 'wo-editorial-price'), amount = el('strong'), unit = el('small', '', t('price_unit', { currency: currency }));
      price.append(amount, unit);
      var installments = el('div', 'wo-vehicle-installments'), installmentVersion = 0, installmentVisible = false, installmentVariant = null;
      function refreshInstallments(variant) {
        installmentVariant = variant;
        var version = ++installmentVersion;
        installments.replaceChildren();
        if (!installmentVisible) return;
        installmentMarkup(variant).then(function (template) {
          if (version !== installmentVersion || !article.isConnected) return;
          var form = document.importNode(template, true), terms = form.querySelector('shopify-payment-terms'), input = form.querySelector('input[name="id"]');
          var id = String(variant.id).split('/').pop(), meta;
          try { meta = JSON.parse(terms.getAttribute('shopify-meta')); } catch (_) { return; }
          var priced = meta.variants?.find(function (item) { return String(item.id) === id; });
          if (meta.currency_code !== currency || !priced || Math.abs(Number(priced.full_price_amount) - Number(variant.price)) > 0.005) return;
          form.id = 'wo-vehicle-installments-' + id;
          form.addEventListener('submit', function (event) { event.preventDefault(); });
          input.value = id;
          terms.setAttribute('variant-id', id);
          installments.append(form);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }).catch(function () {});
      }
      article.woLoadInstallments = function () {
        installmentVisible = true;
        if (installmentVariant) refreshInstallments(installmentVariant);
      };

      var axleLabel = el('p', 'wo-vehicle-card-axle'); axleLabel.hidden = !s.staggered;
      var size = el('p', 'wo-vehicle-card-size'), availability = el('p', 'wo-vehicle-card-availability');
      var plusSize = el('p', 'wo-vehicle-plus-size', t('plus_size')); plusSize.hidden = true;
      var finishes = el('div', 'wo-card-finishes'), selectedFinish = el('p', 'wo-vehicle-selected-finish'), swatches = el('div', 'wo-card-swatch-list wo-vehicle-swatches');
      finishes.append(selectedFinish, swatches); info.append(brandNode, title, price, installments, axleLabel, size, plusSize, availability, finishes);
      article.append(imageLink, info); wrapper.append(article);
      var buttons = [], firstByFinish = new Map();
      group.variants.forEach(function (match) { var key = finish(match); if (key && !firstByFinish.has(key)) firstByFinish.set(key, match); });
      function update(match) {
        var variant = match.variant, spec = match.specification, name = finish(match), src = sameFinishImage(match);
        var label = t('size', { diameter: spec.diameter, width: spec.width, pcd: variant.patterns.join('/'), offset: spec.offset });
        var href = productUrl(variant, s.staggered ? s.axle : null);
        axleLabel.textContent = s.staggered ? t(s.axle + '_axle') : '';
        if (s.staggered) article.dataset.woAxle = s.axle;
        imageLink.href = href; titleLink.href = href; article.dataset.variantId = String(variant.id);
        imageLink.setAttribute('aria-label', t('view_wheel', { title: group.title, finish: name || t('finish_unknown'), size: label }));
        titleLink.setAttribute('aria-label', t('view_wheel', { title: group.title, finish: name || t('finish_unknown'), size: label }));
        brandNode.textContent = brand(match); titleLink.textContent = cardTitle(match); amount.textContent = money(variant); size.textContent = label;
        refreshInstallments(variant);
        availability.textContent = variant.backorder ? t('backorder') : t('available');
        var diameterIncrease = Number(match.diameterIncrease);
        plusSize.hidden = !Number.isFinite(diameterIncrease) || diameterIncrease <= 0;
        selectedFinish.textContent = name || t('finish_unknown');
        image.hidden = !src; placeholder.hidden = Boolean(src);
        image.alt = t('wheel_image', { title: group.title, finish: name || t('finish_unknown') });
        if (src) {
          var responsive = imageForWidth(src, 320) !== src || imageForWidth(src, 640) !== src;
          if (responsive) {
            image.sizes = '(min-width:1440px) 18vw, (min-width:1200px) 22vw, (min-width:992px) 28vw, 43vw';
            image.srcset = [320, 480, 640].map(function (width) { return imageForWidth(src, width) + ' ' + width + 'w'; }).join(', ');
          } else { image.removeAttribute('srcset'); image.removeAttribute('sizes'); }
          image.src = imageForWidth(src, 480);
        } else { image.removeAttribute('src'); image.removeAttribute('srcset'); image.removeAttribute('sizes'); }
        buttons.forEach(function (entry) { entry.button.setAttribute('aria-pressed', String(entry.finish === name)); });
      }
      firstByFinish.forEach(function (match, name) {
        var swatch = el('button', 'wo-vehicle-swatch'); swatch.type = 'button'; swatch.title = name; swatch.setAttribute('aria-label', t('show_finish', { finish: name })); swatch.setAttribute('aria-pressed', 'false');
        var src = sameFinishImage(match);
        if (src) { var thumb = el('img'); thumb.src = imageForWidth(src, 100); thumb.alt = ''; thumb.loading = 'lazy'; thumb.width = 40; thumb.height = 40; swatch.append(thumb); }
        else swatch.append(el('span', '', name.slice(0, 2)));
        buttons.push({ button: swatch, finish: name }); swatches.append(swatch);
        swatch.addEventListener('mouseenter', function () { update(match); });
        swatch.addEventListener('focus', function () { update(match); });
        swatch.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); update(match); });
      });
      image.addEventListener('error', function () { image.hidden = true; placeholder.hidden = false; });
      update(group.variants[0]);
      if (installmentObserver) installmentObserver.observe(article); else article.woLoadInstallments();
      return wrapper;
    }
    function render() {
      if (installmentObserver) installmentObserver.disconnect();
      ui.mobileDiameterAll.setAttribute('aria-pressed', String(s.filters.diameter.size === 0));
      ui.mobileDiameterButtons.forEach(function (button, value) { button.setAttribute('aria-pressed', String(s.filters.diameter.has(value))); });
      ui.filterBody.querySelectorAll('input[data-wo-filter]').forEach(function (input) { input.checked = s.filters[input.dataset.woFilter].has(input.value); });
      s.groups = groups();
      var total = s.groups.length, pages = Math.max(1, Math.ceil(total / PAGE_SIZE)); s.page = Math.max(1, Math.min(s.page, pages));
      ui.layout.hidden = false; ui.count.textContent = t(total === 1 ? 'products_one' : 'products_other', { count: total.toLocaleString(locale) });
      ui.priceNote.hidden = s.priceRejected === 0; ui.priceNote.textContent = t('price_filtered', { currency: currency });
      ui.empty.hidden = total > 0; ui.empty.textContent = s.matches.length ? t('no_filter_results') : s.staggered ? t('no_axle_results', { axle: t(s.axle + '_axle').toLowerCase() }) : t('no_results');
      var fragment = document.createDocumentFragment();
      s.groups.slice((s.page - 1) * PAGE_SIZE, s.page * PAGE_SIZE).forEach(function (group, index) { fragment.append(card(group, index)); }); ui.grid.replaceChildren(fragment);
      ui.pager.hidden = pages <= 1; ui.page.textContent = t('page', { page: s.page, pages: pages }); ui.previous.disabled = s.page <= 1; ui.next.disabled = s.page >= pages;
      rememberCompleted();
    }
    function clearHiddenMobileFilters() {
      if (!mobileViewport.matches) return;
      var changed = s.filters.brand.size > 0 || s.filters.finish.size > 0;
      s.filters.brand.clear(); s.filters.finish.clear();
      ui.filterBody.querySelectorAll('input[data-wo-filter="brand"], input[data-wo-filter="finish"]').forEach(function (input) { input.checked = false; });
      if (changed) { s.page = 1; if (!ui.layout.hidden && !s.busy) render(); }
    }
    mobileViewport.addEventListener('change', clearHiddenMobileFilters);
    ui.cancel.addEventListener('click', function () { s.controller?.abort(); status(t('cancelled')); ui.errorText.textContent = t('cancelled'); ui.error.hidden = false; });
    ui.retry.addEventListener('click', function () { if (!s.busy && s.last) search(s.last, s.lastForce, s.lastResume); });
    ui.refresh.addEventListener('click', function () { if (!s.busy && s.last) search(s.last, true); });
    ui.sort.addEventListener('change', function () { s.sort = ui.sort.value; s.page = 1; render(); });
    ui.mobileDiameterAll.addEventListener('click', function () { s.filters.diameter.clear(); s.page = 1; render(); });
    ui.clear.addEventListener('click', function () { Object.values(s.filters).forEach(function (set) { set.clear(); }); ui.filterBody.querySelectorAll('input').forEach(function (input) { input.checked = false; }); s.page = 1; render(); });
    ui.previous.addEventListener('click', function () { if (s.page > 1) { s.page--; render(); ui.layout.scrollIntoView({ block: 'start' }); } });
    ui.next.addEventListener('click', function () { if (s.page < Math.ceil(s.groups.length / PAGE_SIZE)) { s.page++; render(); ui.layout.scrollIntoView({ block: 'start' }); } });
    activeController = { search: search, clear: function () { clearResults(t('changed')); }, reset: function () { clearResults(); }, root: root };
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted || !document.contains(root)) return;
      var shared = readVehicleReference(root);
      if (!shared || !s.last || !vehiclesMatch(shared.detail.vehicle, s.last.vehicle)) clearResults();
    });
    var url = new URL(location.href), nonce = url.searchParams.get('intent');
    if (nonce) {
      var intent = null;
      try { intent = JSON.parse(sessionStorage.getItem(INTENT_KEY) || 'null'); sessionStorage.removeItem(INTENT_KEY); } catch (_) { intent = null; }
      url.searchParams.delete('intent'); history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      var intentDetail = validDetail(intent?.detail), urlVehicle = window.WOVehicleUrl?.read(url);
      var sameVehicle = intentDetail && urlVehicle && KEYS.every(function (key) { return urlVehicle[key] === intentDetail.vehicle[key]; });
      var sameTarget = intent?.targetPath === url.pathname.replace(/\/$/, '') ||
        (intent?.targetPath === undefined && /^(?:\/[a-z]{2}(?:-[A-Za-z]{2})?)?\/collections\/wheels\/?$/.test(url.pathname) && !catalogUrl);
      if (sameTarget && intent && intent.nonce === nonce && typeof intent.timestamp === 'number' && Date.now() - intent.timestamp >= 0 && Date.now() - intent.timestamp <= INTENT_TTL && sameVehicle) search(intentDetail, false);
      else { discardResults(); status(t('expired')); }
    } else { discardIntent(); restoreCompleted(); }
  }
  function discardIntent() {
    try { sessionStorage.removeItem(INTENT_KEY); } catch (_) {}
    var url = new URL(location.href);
    if (url.searchParams.has('intent')) {
      url.searchParams.delete('intent'); history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }
  }
  function initWithin(root) {
    if (root.matches?.('[data-wo-vehicle-results]')) initialize(root);
    root.querySelectorAll('[data-wo-vehicle-results]').forEach(initialize);
    if (root.matches?.('[data-wo-vehicle-picker]')) resumeBrandLanding(root);
    root.querySelectorAll('[data-wo-vehicle-picker]').forEach(resumeBrandLanding);
  }
  document.addEventListener('wo:vehicle-submit', function (event) {
    var detail = validDetail(event.detail); if (!detail) return;
    event.preventDefault();
    if (activeController && document.contains(activeController.root)) {
      if (!window.WOVehicleUrl?.write(detail)) return;
      discardIntent(); activeController.search(detail, false); return;
    }
    var picker = event.target.closest('[data-wo-vehicle-picker]'), destination;
    try {
      destination = collectionTarget(picker?.hasAttribute('data-wo-collection-url') ? picker.dataset.woCollectionUrl : '/collections/wheels');
    } catch (_) {
      var scopeStatus = picker?.querySelector('[role="status"]');
      if (scopeStatus) scopeStatus.textContent = STRINGS.catalog_error;
      return;
    }
    var nonce = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
    try { sessionStorage.setItem(INTENT_KEY, JSON.stringify({ nonce: nonce, timestamp: Date.now(), detail: detail, targetPath: destination.pathname })); }
    catch (_) { var status = picker?.querySelector('[role="status"]'); if (status) status.textContent = STRINGS.storage_error; return; }
    destination.searchParams.set('view', 'vehicle'); destination.searchParams.set('intent', nonce);
    var preview = new URL(location.href).searchParams.get('preview_theme_id'); if (preview) destination.searchParams.set('preview_theme_id', preview);
    destination = window.WOVehicleUrl?.withVehicle(detail, destination);
    if (!destination) { discardIntent(); return; }
    location.assign(destination.pathname + destination.search + destination.hash);
  });
  document.addEventListener('wo:vehicle-reset', function () {
    discardIntent(); discardResults(); discardVehicleReference(); window.WOVehicleUrl?.clear();
    var url = new URL(location.href);
    ['axle', 'wo_vehicle'].forEach(function (key) { url.searchParams.delete(key); });
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    if (activeController && document.contains(activeController.root)) activeController.reset();
    if (url.searchParams.get('view') === 'vehicle' && /^(?:\/[a-z]{2}(?:-[A-Za-z]{2})?)?\/collections\/[a-z0-9][a-z0-9-]*\/?$/.test(url.pathname)) {
      url.searchParams.delete('view');
      location.replace(url.pathname + url.search + url.hash);
    }
  });
  document.addEventListener('wo:vehicle-invalid', function () {
    discardIntent(); discardResults(); discardVehicleReference();
    if (activeController && document.contains(activeController.root)) activeController.clear();
  });
  document.addEventListener('change', function (event) {
    if (!event.target.closest?.('[data-wo-vehicle-picker]')) return;
    discardIntent(); discardResults(); discardVehicleReference(); window.WOVehicleUrl?.clear();
    if (activeController && document.contains(activeController.root)) activeController.clear();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initWithin(document); }, { once: true });
  else initWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
})();
})();

